// Texte der Team-Umfrage (TeamSurvey.svelte). Die Antwortwerte sind die Optionen von
// activityFitQuestions (lib/util/frameworkReadiness.js); hier stehen nur ihre Anzeigenamen.
// Zeitanteil wird nicht mehr gefragt (02.10.: wirkte wie Zeiterfassung). Aeltere Antworten tragen ihn noch - sie
// werden grob als Raum angezeigt, nie als Prozent.
export const weightOf = (share) => (share >= 25 ? 30 : share >= 10 ? 15 : share ? 5 : 0);
// Denkanstoesse statt Zeitbilanz: Taetigkeiten, aus denen aufnehmbare Aufgaben werden (Verb + Gegenstand, mit Anfang
// und Ergebnis - wie die L4 im Framework). Kanaele wie E-Mails oder Abstimmungen fuehrten zu unspezifischen Eintraegen.
export const IDEA_AREAS = ["create", "check", "book", "maintain", "incoming", "report"];
// Dauer eines Durchlaufs (Rueckmeldung 02.10.): trennt Einzelschritte und Ablaeufe ueber Tage von aufnehmbaren Aufgaben.
// Werte wie DURATION in backend/dam/team_survey.py.
export const DURATIONS = ["Under 5 minutes", "5-30 minutes", "30-60 minutes", "Over 1 hour"];

// Beispiele je Art des Teams, erkannt am Teamnamen; sonst allgemeine. Vorbild sind echte L4 aus Kundenprojekten
// (z. B. "Review Incoming and Vendor Invoices", "Update Vendor Bank Details", "Create Price Contract").
const IDEA_TYPES = [
  ["finance", /buchhalt|kreditor|debitor|finanz|rechnungswesen|controlling|accounting|financ|payable|receivable/i],
  ["purchasing", /einkauf|beschaffung|purchas|procure|sourcing/i],
  ["sales", /vertrieb|verkauf|innendienst|auftragsab|sales|order management/i],
  ["logistics", /lager|logistik|versand|wareneingang|warehouse|logistic|shipping/i],
  ["hr", /personal|lohn|gehalt|\bhr\b|human|payroll|recruit/i],
  ["service", /service|kundendienst|support|customer/i],
];

const TASK_IDEAS = {
  de: {
    finance: {
      create: ["Ausgangsrechnungen erstellen", "Gutschriften erstellen"],
      check: ["Rechnungsdaten prüfen", "Reisekostenabrechnungen prüfen"],
      book: ["Eingangsrechnungen im System buchen", "Abgrenzungen zum Monatsende buchen"],
      maintain: ["Lieferantenstammdaten pflegen", "Bankverbindungen von Lieferanten ändern"],
      incoming: ["Zahlungserinnerung prüfen", "Rückfragen von Lieferanten zu Zahlungen klären"],
      report: ["Zahlungslauf vorbereiten", "Offene Posten auswerten"],
    },
    purchasing: {
      create: ["Bestellungen anlegen", "Preiskontrakte anlegen"],
      check: ["Lieferantenangebote vergleichen", "Lieferanten auditieren"],
      book: ["Auftragsbestätigungen erfassen", "Liefertermine im System nachtragen"],
      maintain: ["Preiskontrakte aktualisieren", "Materialstammdaten pflegen"],
      incoming: ["Bestellanforderung prüfen", "Lieferverzug nachverfolgen"],
      report: ["Einsparpotenziale auswerten", "Wöchentlichen Einkaufsbericht erstellen"],
    },
    sales: {
      create: ["Angebote erstellen", "Kundenaufträge anlegen"],
      check: ["Kreditlimit vor der Auftragsfreigabe prüfen", "Sonderpreise freigeben"],
      book: ["Auftragsänderungen erfassen", "Lieferungen im System anlegen"],
      maintain: ["Kundenstammdaten pflegen", "Preislisten aktualisieren"],
      incoming: ["Kundenanfragen zu Lieferterminen beantworten", "Kundenreklamation erfassen"],
      report: ["Auftragseingang auswerten", "Absatzplanung aktualisieren"],
    },
    logistics: {
      create: ["Versandpapiere erstellen", "Transportaufträge anlegen"],
      check: ["Wareneingang gegen Lieferschein prüfen", "Inventurdifferenzen prüfen"],
      book: ["Wareneingang buchen", "Warenausgang buchen"],
      maintain: ["Lagerplätze im System pflegen", "Artikelstammdaten ergänzen"],
      incoming: ["Retoure erfassen", "Transportschaden melden"],
      report: ["Bestandsliste auswerten", "Versandübersicht für den Tag erstellen"],
    },
    hr: {
      create: ["Arbeitsverträge erstellen", "Arbeitszeugnisse erstellen"],
      check: ["Urlaubsantrag genehmigen", "Reisekosten prüfen"],
      book: ["Neue Mitarbeitende im System anlegen", "Krankmeldungen erfassen"],
      maintain: ["Personalstammdaten pflegen", "Zeitkonten korrigieren"],
      incoming: ["Bewerbung sichten", "Bescheinigungen auf Anfrage ausstellen"],
      report: ["Abwesenheitsübersicht erstellen", "Daten für die Lohnabrechnung vorbereiten"],
    },
    service: {
      create: ["Servicetickets anlegen", "Serviceaufträge erstellen"],
      check: ["Garantieansprüche prüfen", "Technikereinsatz abschließen"],
      book: ["Ersatzteilverbrauch erfassen", "Einsatzberichte im System erfassen"],
      maintain: ["Kundenanlagen im System pflegen", "Wartungsverträge aktualisieren"],
      incoming: ["Kundenreklamation erfassen", "Störungsmeldung erfassen"],
      report: ["Wöchentliche Ticketauswertung erstellen", "Abschlussbericht zum Auftrag erstellen"],
    },
    general: {
      create: ["Rechnungen erstellen", "Angebote erstellen"],
      check: ["Antrag freigeben", "Lieferanten auditieren"],
      book: ["Belege im System erfassen", "Bestellungen anlegen"],
      maintain: ["Stammdaten pflegen", "Preislisten aktualisieren"],
      incoming: ["Reklamation erfassen", "Kundenanfragen zu Aufträgen beantworten"],
      report: ["Monatsbericht erstellen", "Kennzahlen für die Leitung auswerten"],
    },
  },
  en: {
    finance: {
      create: ["Create outgoing invoices", "Create credit notes"],
      check: ["Validate invoice data", "Review travel expense reports"],
      book: ["Post incoming invoices in the system", "Post month-end accruals"],
      maintain: ["Maintain vendor master data", "Update vendor bank details"],
      incoming: ["Check payment reminder", "Clarify vendor questions about payments"],
      report: ["Prepare payment runs", "Analyse open items"],
    },
    purchasing: {
      create: ["Create purchase orders", "Create price contracts"],
      check: ["Compare supplier quotes", "Audit suppliers"],
      book: ["Enter order confirmations", "Update delivery dates in the system"],
      maintain: ["Update price contracts", "Maintain material master data"],
      incoming: ["Check purchase requisition", "Follow up on late deliveries"],
      report: ["Analyse saving potential", "Create the weekly purchasing report"],
    },
    sales: {
      create: ["Create quotes", "Create customer orders"],
      check: ["Check the credit limit before releasing orders", "Approve special prices"],
      book: ["Enter order changes", "Create deliveries in the system"],
      maintain: ["Maintain customer master data", "Update price lists"],
      incoming: ["Answer customer questions about delivery dates", "Register customer complaint"],
      report: ["Analyse incoming orders", "Update the sales forecast"],
    },
    logistics: {
      create: ["Create shipping documents", "Create transport orders"],
      check: ["Check goods receipts against the delivery note", "Check inventory differences"],
      book: ["Post goods receipts", "Post goods issues"],
      maintain: ["Maintain storage bins in the system", "Complete article master data"],
      incoming: ["Register return", "Report transport damage"],
      report: ["Analyse the stock list", "Create the daily shipping overview"],
    },
    hr: {
      create: ["Create employment contracts", "Create references"],
      check: ["Approve leave request", "Review travel expenses"],
      book: ["Create new employees in the system", "Enter sick notes"],
      maintain: ["Maintain employee master data", "Correct time accounts"],
      incoming: ["Screen application", "Issue certificates on request"],
      report: ["Create the absence overview", "Prepare data for payroll"],
    },
    service: {
      create: ["Create service tickets", "Create service orders"],
      check: ["Check warranty claims", "Close technician visit"],
      book: ["Enter spare part usage", "Enter visit reports in the system"],
      maintain: ["Maintain customer installations in the system", "Update maintenance contracts"],
      incoming: ["Register customer complaint", "Register incident report"],
      report: ["Create the weekly ticket report", "Create the final order report"],
    },
    general: {
      create: ["Create invoices", "Create quotes"],
      check: ["Approve request", "Audit suppliers"],
      book: ["Enter documents in the system", "Create purchase orders"],
      maintain: ["Maintain master data", "Update price lists"],
      incoming: ["Register complaint", "Answer customer questions about orders"],
      report: ["Create the monthly report", "Analyse figures for management"],
    },
  },
  fr: {
      finance: {
        create: ["Établir la facture client", "Établir l'avoir"],
        check: ["Vérifier les données de la facture", "Contrôler la note de frais"],
        book: ["Comptabiliser la facture fournisseur dans le système", "Passer l'écriture de régularisation de fin de mois"],
        maintain: ["Mettre à jour les données de base fournisseur", "Modifier les coordonnées bancaires d'un fournisseur"],
        incoming: ["Vérifier la relance de paiement", "Répondre à la question d'un fournisseur sur un paiement"],
        report: ["Préparer le lot de paiements", "Analyser les postes ouverts"],
      },
      purchasing: {
        create: ["Créer la commande d'achat", "Créer le contrat de prix"],
        check: ["Comparer les offres fournisseurs", "Auditer le fournisseur"],
        book: ["Saisir la confirmation de commande", "Mettre à jour la date de livraison dans le système"],
        maintain: ["Mettre à jour le contrat de prix", "Mettre à jour les données de base article"],
        incoming: ["Vérifier la demande d'achat", "Relancer une livraison en retard"],
        report: ["Analyser le potentiel d'économies", "Établir le rapport d'achats hebdomadaire"],
      },
      sales: {
        create: ["Établir le devis", "Créer la commande client"],
        check: ["Vérifier la limite de crédit avant de libérer la commande", "Valider un prix spécial"],
        book: ["Saisir la modification de commande", "Créer la livraison dans le système"],
        maintain: ["Mettre à jour les données de base client", "Mettre à jour la liste de prix"],
        incoming: ["Répondre à la question d'un client sur la date de livraison", "Enregistrer la réclamation client"],
        report: ["Analyser les entrées de commandes", "Mettre à jour la prévision des ventes"],
      },
      logistics: {
        create: ["Établir les documents d'expédition", "Créer l'ordre de transport"],
        check: ["Contrôler l'entrée de marchandises avec le bon de livraison", "Vérifier l'écart d'inventaire"],
        book: ["Comptabiliser l'entrée de marchandises", "Comptabiliser la sortie de marchandises"],
        maintain: ["Mettre à jour les emplacements de stockage dans le système", "Compléter les données de base article"],
        incoming: ["Enregistrer le retour", "Déclarer un dommage de transport"],
        report: ["Analyser la liste des stocks", "Établir le récapitulatif des expéditions du jour"],
      },
      hr: {
        create: ["Établir le contrat de travail", "Rédiger le certificat de travail"],
        check: ["Valider la demande de congé", "Contrôler les frais de déplacement"],
        book: ["Créer un nouveau collaborateur dans le système", "Saisir l'arrêt maladie"],
        maintain: ["Mettre à jour les données du personnel", "Corriger le compteur d'heures"],
        incoming: ["Examiner la candidature", "Délivrer une attestation sur demande"],
        report: ["Établir le tableau des absences", "Préparer les données pour la paie"],
      },
      service: {
        create: ["Créer le ticket de service", "Créer l'ordre d'intervention"],
        check: ["Vérifier la demande de garantie", "Clôturer l'intervention du technicien"],
        book: ["Saisir la consommation de pièces détachées", "Saisir le rapport d'intervention dans le système"],
        maintain: ["Mettre à jour les installations client dans le système", "Mettre à jour le contrat de maintenance"],
        incoming: ["Enregistrer la réclamation client", "Enregistrer le signalement de panne"],
        report: ["Établir le bilan hebdomadaire des tickets", "Établir le rapport final de l'intervention"],
      },
      general: {
        create: ["Établir la facture", "Établir le devis"],
        check: ["Valider la demande", "Auditer le fournisseur"],
        book: ["Saisir la pièce dans le système", "Créer la commande d'achat"],
        maintain: ["Mettre à jour les données de base", "Mettre à jour la liste de prix"],
        incoming: ["Enregistrer la réclamation", "Répondre à la question d'un client sur une commande"],
        report: ["Établir le rapport mensuel", "Analyser les indicateurs pour la direction"],
      },
    },
  it: {
    finance: {
      create: ["Emettere la fattura di vendita", "Emettere la nota di credito"],
      check: ["Verificare i dati della fattura", "Controllare la nota spese di trasferta"],
      book: ["Registrare la fattura in entrata nel sistema", "Registrare i ratei di fine mese"],
      maintain: ["Aggiornare l'anagrafica fornitore", "Modificare le coordinate bancarie del fornitore"],
      incoming: ["Verificare il sollecito di pagamento", "Chiarire le domande del fornitore sui pagamenti"],
      report: ["Preparare il ciclo di pagamenti", "Analizzare le partite aperte"],
    },
    purchasing: {
      create: ["Creare l'ordine d'acquisto", "Creare il contratto prezzi"],
      check: ["Confrontare le offerte dei fornitori", "Fare l'audit del fornitore"],
      book: ["Registrare la conferma d'ordine", "Aggiornare la data di consegna nel sistema"],
      maintain: ["Aggiornare il contratto prezzi", "Aggiornare l'anagrafica materiale"],
      incoming: ["Verificare la richiesta d'acquisto", "Sollecitare la consegna in ritardo"],
      report: ["Analizzare i potenziali risparmi", "Preparare il report acquisti settimanale"],
    },
    sales: {
      create: ["Preparare l'offerta", "Creare l'ordine cliente"],
      check: ["Verificare il fido prima di sbloccare l'ordine", "Approvare il prezzo speciale"],
      book: ["Registrare la modifica d'ordine", "Creare la consegna nel sistema"],
      maintain: ["Aggiornare l'anagrafica cliente", "Aggiornare il listino prezzi"],
      incoming: ["Rispondere al cliente sulla data di consegna", "Registrare il reclamo del cliente"],
      report: ["Analizzare gli ordini in entrata", "Aggiornare la previsione di vendita"],
    },
    logistics: {
      create: ["Preparare i documenti di spedizione", "Creare l'ordine di trasporto"],
      check: ["Controllare la merce in entrata con il documento di trasporto", "Verificare le differenze inventariali"],
      book: ["Registrare l'entrata merci", "Registrare l'uscita merci"],
      maintain: ["Aggiornare le ubicazioni di magazzino nel sistema", "Completare l'anagrafica articolo"],
      incoming: ["Registrare il reso", "Segnalare il danno da trasporto"],
      report: ["Analizzare l'elenco delle giacenze", "Preparare il riepilogo spedizioni del giorno"],
    },
    hr: {
      create: ["Preparare il contratto di lavoro", "Redigere la lettera di referenze"],
      check: ["Approvare la richiesta di ferie", "Controllare le spese di trasferta"],
      book: ["Inserire il nuovo dipendente nel sistema", "Registrare il certificato di malattia"],
      maintain: ["Aggiornare l'anagrafica dipendente", "Correggere la banca ore"],
      incoming: ["Valutare la candidatura", "Rilasciare un certificato su richiesta"],
      report: ["Preparare il riepilogo delle assenze", "Preparare i dati per le buste paga"],
    },
    service: {
      create: ["Aprire il ticket di assistenza", "Creare l'ordine di assistenza"],
      check: ["Verificare la richiesta di garanzia", "Chiudere l'intervento del tecnico"],
      book: ["Registrare i ricambi utilizzati", "Inserire il rapporto d'intervento nel sistema"],
      maintain: ["Aggiornare gli impianti del cliente nel sistema", "Aggiornare il contratto di manutenzione"],
      incoming: ["Registrare il reclamo del cliente", "Registrare la segnalazione di guasto"],
      report: ["Preparare il report settimanale dei ticket", "Preparare il rapporto finale dell'ordine"],
    },
    general: {
      create: ["Emettere la fattura", "Preparare l'offerta"],
      check: ["Approvare la richiesta", "Fare l'audit del fornitore"],
      book: ["Registrare il documento nel sistema", "Creare l'ordine d'acquisto"],
      maintain: ["Aggiornare i dati anagrafici", "Aggiornare il listino prezzi"],
      incoming: ["Registrare il reclamo", "Rispondere al cliente sugli ordini"],
      report: ["Preparare il report mensile", "Analizzare gli indicatori per la direzione"],
    },
  },
  es: {
      finance: {
        create: ["Emitir la factura de cliente", "Emitir la nota de abono"],
        check: ["Comprobar los datos de la factura", "Revisar la liquidación de gastos de viaje"],
        book: ["Contabilizar la factura de proveedor en el sistema", "Contabilizar la periodificación de cierre de mes"],
        maintain: ["Mantener los datos maestros del proveedor", "Cambiar los datos bancarios del proveedor"],
        incoming: ["Revisar el recordatorio de pago", "Aclarar consultas de proveedores sobre pagos"],
        report: ["Preparar la remesa de pagos", "Analizar las partidas abiertas"],
      },
      purchasing: {
        create: ["Crear el pedido de compra", "Crear el contrato de precios"],
        check: ["Comparar las ofertas de proveedores", "Auditar al proveedor"],
        book: ["Registrar la confirmación de pedido", "Actualizar la fecha de entrega en el sistema"],
        maintain: ["Actualizar el contrato de precios", "Mantener los datos maestros del material"],
        incoming: ["Revisar la solicitud de pedido", "Hacer seguimiento de una entrega con retraso"],
        report: ["Analizar el potencial de ahorro", "Preparar el informe semanal de compras"],
      },
      sales: {
        create: ["Preparar la oferta", "Crear el pedido de cliente"],
        check: ["Comprobar el límite de crédito antes de liberar el pedido", "Aprobar un precio especial"],
        book: ["Registrar el cambio de pedido", "Crear la entrega en el sistema"],
        maintain: ["Mantener los datos maestros del cliente", "Actualizar la lista de precios"],
        incoming: ["Responder consultas de clientes sobre plazos de entrega", "Registrar la reclamación del cliente"],
        report: ["Analizar la entrada de pedidos", "Actualizar la previsión de ventas"],
      },
      logistics: {
        create: ["Preparar los documentos de envío", "Crear la orden de transporte"],
        check: ["Comprobar la entrada de mercancía con el albarán", "Revisar las diferencias de inventario"],
        book: ["Contabilizar la entrada de mercancía", "Contabilizar la salida de mercancía"],
        maintain: ["Mantener las ubicaciones del almacén en el sistema", "Completar los datos maestros del artículo"],
        incoming: ["Registrar la devolución", "Comunicar un daño de transporte"],
        report: ["Analizar la lista de existencias", "Preparar el resumen diario de envíos"],
      },
      hr: {
        create: ["Redactar el contrato de trabajo", "Redactar el certificado de empresa"],
        check: ["Aprobar la solicitud de vacaciones", "Revisar los gastos de viaje"],
        book: ["Dar de alta a un nuevo empleado en el sistema", "Registrar la baja por enfermedad"],
        maintain: ["Mantener los datos maestros del personal", "Corregir la cuenta de horas"],
        incoming: ["Revisar la candidatura", "Emitir un certificado a petición"],
        report: ["Preparar el resumen de ausencias", "Preparar los datos para la nómina"],
      },
      service: {
        create: ["Crear el ticket de servicio", "Crear la orden de servicio"],
        check: ["Revisar la reclamación de garantía", "Cerrar la intervención del técnico"],
        book: ["Registrar el consumo de repuestos", "Registrar el informe de intervención en el sistema"],
        maintain: ["Mantener las instalaciones del cliente en el sistema", "Actualizar el contrato de mantenimiento"],
        incoming: ["Registrar la reclamación del cliente", "Registrar el aviso de avería"],
        report: ["Preparar el informe semanal de tickets", "Preparar el informe final de la orden"],
      },
      general: {
        create: ["Emitir la factura", "Preparar la oferta"],
        check: ["Aprobar la solicitud", "Auditar al proveedor"],
        book: ["Registrar documentos en el sistema", "Crear el pedido de compra"],
        maintain: ["Mantener los datos maestros", "Actualizar la lista de precios"],
        incoming: ["Registrar la reclamación", "Responder consultas de clientes sobre pedidos"],
        report: ["Preparar el informe mensual", "Analizar las cifras para la dirección"],
      },
    },
};

// Das Beispiel auf Begruessung, Aufgabenseite und in den Platzhaltern (ueberall dasselbe, Rueckmeldung 02.10.):
// Taetigkeit + Gegenstand und ein Ablauf in Ich-Form mit klarem Anfang und Ende. [Name, Ablauf, kurzer Ablauf fuer den Platzhalter]
const TASK_EXAMPLES = {
  de: {
    finance: ["Eingangsrechnung abgleichen", "Ich öffne die Rechnung und die zugehörige Bestellung, vergleiche Angaben und Beträge und kläre mögliche Abweichungen. Die Aufgabe ist erledigt, wenn ich die Rechnung freigegeben oder zur Klärung weitergegeben habe.", "Ich gleiche die Rechnung mit der Bestellung ab."],
    purchasing: ["Bestellung anlegen", "Ich öffne die freigegebene Bestellanforderung, wähle den Lieferanten, lege die Bestellung im System an und prüfe Preise und Termine. Die Aufgabe ist erledigt, wenn die Bestellung an den Lieferanten verschickt ist.", "Ich lege aus der Anforderung eine Bestellung an."],
    sales: ["Kundenauftrag anlegen", "Ich öffne die Bestellung des Kunden, lege den Auftrag im System an, prüfe Preise und Liefertermin und kläre Rückfragen. Die Aufgabe ist erledigt, wenn die Auftragsbestätigung verschickt ist.", "Ich lege die Bestellung des Kunden als Auftrag an."],
    logistics: ["Wareneingang buchen", "Ich nehme den Lieferschein, suche die Bestellung im System, gleiche Artikel und Mengen ab und buche den Eingang. Die Aufgabe ist erledigt, wenn die Ware gebucht oder die Abweichung gemeldet ist.", "Ich buche die gelieferte Ware im System ein."],
    hr: ["Neue Mitarbeitende im System anlegen", "Ich nehme den unterschriebenen Vertrag, lege den Personalstamm an, trage Arbeitszeit, Gehalt und Bankdaten ein und prüfe die Angaben. Die Aufgabe ist erledigt, wenn der Datensatz vollständig an die Lohnabrechnung geht.", "Ich lege neue Kolleginnen und Kollegen im System an."],
    service: ["Einsatzbericht erfassen und Auftrag abschließen", "Ich öffne den Bericht des Technikers, erfasse Arbeitszeit und Material im System und prüfe, ob alles vollständig ist. Die Aufgabe ist erledigt, wenn der Auftrag im System abgeschlossen ist.", "Ich trage den Bericht des Technikers ins System ein."],
    general: ["Eingangsrechnung abgleichen", "Ich öffne die Rechnung und die zugehörige Bestellung, vergleiche Angaben und Beträge und kläre mögliche Abweichungen. Die Aufgabe ist erledigt, wenn ich die Rechnung freigegeben oder zur Klärung weitergegeben habe.", "Ich gleiche die Rechnung mit der Bestellung ab."],
  },
  en: {
    finance: ["Match incoming invoice", "I open the invoice and the related purchase order, compare details and amounts and clarify any differences. The task is done when I have approved the invoice or passed it on for clarification.", "I match the invoice with the purchase order."],
    purchasing: ["Create purchase order", "I open the approved purchase requisition, choose the supplier, create the order in the system and check prices and dates. The task is done when the order has been sent to the supplier.", "I turn the requisition into a purchase order."],
    sales: ["Create customer order", "I open the customer's order, create it in the system, check prices and delivery date and clarify questions. The task is done when the order confirmation has been sent.", "I enter the customer's order as a sales order."],
    logistics: ["Post goods receipt", "I take the delivery note, find the purchase order in the system, compare items and quantities and post the receipt. The task is done when the goods are posted or the difference is reported.", "I post the delivered goods in the system."],
    hr: ["Create new employee in the system", "I take the signed contract, create the employee record, enter working time, salary and bank details and check the data. The task is done when the complete record goes to payroll.", "I set up new colleagues in the system."],
    service: ["Enter visit report and close the order", "I open the technician's report, enter working time and material in the system and check that everything is complete. The task is done when the order is closed in the system.", "I enter the technician's report in the system."],
    general: ["Match incoming invoice", "I open the invoice and the related purchase order, compare details and amounts and clarify any differences. The task is done when I have approved the invoice or passed it on for clarification.", "I match the invoice with the purchase order."],
  },
  fr: {
      finance: ["Rapprocher la facture fournisseur", "J'ouvre la facture et la commande correspondante, je compare les informations et les montants et je clarifie les éventuels écarts. La tâche est terminée quand j'ai validé la facture ou que je l'ai transmise pour clarification.", "Je rapproche la facture de la commande."],
      purchasing: ["Créer la commande d'achat", "J'ouvre la demande d'achat validée, je choisis le fournisseur, je crée la commande dans le système et je vérifie les prix et les délais. La tâche est terminée quand la commande est envoyée au fournisseur.", "Je transforme la demande en commande."],
      sales: ["Créer la commande client", "J'ouvre la commande du client, je la saisis dans le système, je vérifie les prix et la date de livraison et je clarifie les questions. La tâche est terminée quand la confirmation de commande est envoyée.", "Je saisis la commande du client dans le système."],
      logistics: ["Comptabiliser l'entrée de marchandises", "Je prends le bon de livraison, je cherche la commande dans le système, je compare les articles et les quantités et je comptabilise l'entrée. La tâche est terminée quand la marchandise est comptabilisée ou l'écart signalé.", "Je comptabilise la marchandise livrée dans le système."],
      hr: ["Créer un nouveau collaborateur dans le système", "Je prends le contrat signé, je crée le dossier du collaborateur, je saisis le temps de travail, le salaire et les coordonnées bancaires et je vérifie les données. La tâche est terminée quand le dossier complet part à la paie.", "Je crée les nouveaux collègues dans le système."],
      service: ["Saisir le rapport d'intervention et clôturer l'ordre", "J'ouvre le rapport du technicien, je saisis le temps de travail et le matériel dans le système et je vérifie que tout est complet. La tâche est terminée quand l'ordre est clôturé dans le système.", "Je saisis le rapport du technicien dans le système."],
      general: ["Rapprocher la facture fournisseur", "J'ouvre la facture et la commande correspondante, je compare les informations et les montants et je clarifie les éventuels écarts. La tâche est terminée quand j'ai validé la facture ou que je l'ai transmise pour clarification.", "Je rapproche la facture de la commande."],
    },
  it: {
    finance: ["Verificare la fattura in entrata", "Apro la fattura e il relativo ordine d'acquisto, confronto dati e importi e chiarisco eventuali differenze. L'attività è conclusa quando ho approvato la fattura o l'ho passata a qualcuno per un chiarimento.", "Confronto la fattura con l'ordine d'acquisto."],
    purchasing: ["Creare l'ordine d'acquisto", "Apro la richiesta d'acquisto approvata, scelgo il fornitore, creo l'ordine nel sistema e controllo prezzi e date. L'attività è conclusa quando l'ordine è stato inviato al fornitore.", "Trasformo la richiesta in un ordine d'acquisto."],
    sales: ["Creare l'ordine cliente", "Apro l'ordine del cliente, lo inserisco nel sistema, controllo prezzi e data di consegna e chiarisco eventuali domande. L'attività è conclusa quando la conferma d'ordine è stata inviata.", "Inserisco l'ordine del cliente nel sistema."],
    logistics: ["Registrare l'entrata merci", "Prendo il documento di trasporto, cerco l'ordine d'acquisto nel sistema, confronto articoli e quantità e registro l'entrata. L'attività è conclusa quando la merce è registrata o la differenza è segnalata.", "Registro nel sistema la merce consegnata."],
    hr: ["Inserire il nuovo dipendente nel sistema", "Prendo il contratto firmato, creo l'anagrafica del dipendente, inserisco orario di lavoro, stipendio e dati bancari e controllo i dati. L'attività è conclusa quando la scheda completa passa all'ufficio paghe.", "Inserisco i nuovi colleghi nel sistema."],
    service: ["Registrare il rapporto d'intervento e chiudere l'ordine", "Apro il rapporto del tecnico, inserisco nel sistema ore di lavoro e materiale e controllo che sia tutto completo. L'attività è conclusa quando l'ordine è chiuso nel sistema.", "Inserisco nel sistema il rapporto del tecnico."],
    general: ["Verificare la fattura in entrata", "Apro la fattura e il relativo ordine d'acquisto, confronto dati e importi e chiarisco eventuali differenze. L'attività è conclusa quando ho approvato la fattura o l'ho passata a qualcuno per un chiarimento.", "Confronto la fattura con l'ordine d'acquisto."],
  },
  es: {
      finance: ["Cotejar la factura de proveedor", "Abro la factura y el pedido correspondiente, comparo los datos y los importes y aclaro las posibles diferencias. La tarea está terminada cuando he aprobado la factura o la he pasado para aclararla.", "Cotejo la factura con el pedido."],
      purchasing: ["Crear el pedido de compra", "Abro la solicitud de pedido aprobada, elijo el proveedor, creo el pedido en el sistema y compruebo precios y fechas. La tarea está terminada cuando el pedido se ha enviado al proveedor.", "Convierto la solicitud en un pedido de compra."],
      sales: ["Crear el pedido de cliente", "Abro el pedido del cliente, lo creo en el sistema, compruebo precios y fecha de entrega y aclaro las dudas. La tarea está terminada cuando se ha enviado la confirmación del pedido.", "Registro el pedido del cliente como pedido de venta."],
      logistics: ["Contabilizar la entrada de mercancía", "Cojo el albarán, busco el pedido en el sistema, comparo artículos y cantidades y contabilizo la entrada. La tarea está terminada cuando la mercancía está contabilizada o la diferencia se ha comunicado.", "Contabilizo la mercancía recibida en el sistema."],
      hr: ["Dar de alta a un nuevo empleado en el sistema", "Cojo el contrato firmado, creo la ficha del empleado, introduzco jornada, salario y datos bancarios y compruebo los datos. La tarea está terminada cuando la ficha completa pasa a nóminas.", "Doy de alta a los nuevos compañeros en el sistema."],
      service: ["Registrar el informe de intervención y cerrar la orden", "Abro el informe del técnico, registro horas y material en el sistema y compruebo que todo esté completo. La tarea está terminada cuando la orden está cerrada en el sistema.", "Registro el informe del técnico en el sistema."],
      general: ["Cotejar la factura de proveedor", "Abro la factura y el pedido correspondiente, comparo los datos y los importes y aclaro las posibles diferencias. La tarea está terminada cuando he aprobado la factura o la he pasado para aclararla.", "Cotejo la factura con el pedido."],
    },
};

const teamType = (team) => IDEA_TYPES.find(([, pattern]) => pattern.test(team || ""))?.[0] || "general";

export function ideaExamples(language, team) {
  return (TASK_IDEAS[language] || TASK_IDEAS.de)[teamType(team)];
}

export function taskExample(language, team) {
  return (TASK_EXAMPLES[language] || TASK_EXAMPLES.de)[teamType(team)];
}

export const teamSurveyTexts = {
  de: {
    locale: "de-DE",
    // Schrittanzeige oben rechts wie im Framework Assistant
    steps: { collect: ["Start", "Pax AI", "Aufgaben", "Prüfen"], select: ["Start", "Auswählen"] },
    lightMode: "Hell",
    darkMode: "Dunkel",
    product: "Task Mining",
    area: "Team-Umfrage",
    stepOf: (step, total) => `Schritt ${step} von ${total}`,
    duration: "Dauer",
    anonymous: "Anonym: niemand sieht, wer was eingetragen hat.",
    openUntil: (date) => `Offen bis ${date}`,
    lateOpen: "Die Frist ist vorbei. Eintragen geht trotzdem noch.",
    notFound: "Diese Umfrage gibt es nicht (mehr). Prüf bitte den Link oder frag im Projektteam nach.",
    preparing: "Die gemeinsame Liste wird gerade zusammengestellt …",
    preparingHint: "Das dauert meist unter einer Minute. Die Seite aktualisiert sich von selbst.",
    saveError: "Das Speichern hat nicht geklappt. Bitte gleich noch einmal versuchen.",
    stageChanged: "Die Sammelphase ist inzwischen beendet. Jetzt geht es ans gemeinsame Auswählen.",
    stageChangedSent: "Danke, deine Aufgaben sind drin! Alle Antworten sind zusammengefasst. Jetzt geht es ans gemeinsame Auswählen.",
    draftSaved: "Zwischenstand gespeichert",
    draftSavedEverywhere: "Zwischenstand gespeichert. Du kannst auch auf einem anderen Gerät weitermachen",
    alreadySent: "Du hast schon abgeschickt, vermutlich auf einem anderen Gerät. Danke fürs Mitmachen!",
    back: "Zurück",
    start: "Los geht's",
    optional: "optional",
    departmentLabel: "Abteilung",
    assist: {
      title: "Möchtest du Unterstützung beim Sammeln deiner Aufgaben?",
      lead: "Pax AI kann dir anhand deiner Angaben Aufgabenideen vorschlagen. Du entscheidest, welche davon zu deiner Arbeit passen, und kannst sie anpassen.",
      yes: "Ja, zeig mir Ideen",
      no: "Nein, ich schreibe selbst",
      loading: "Pax AI stellt Aufgabenideen zusammen …",
      error: "Aufgabenideen für deinen Bereich gehen gerade nicht. Hier stehen allgemeine Beispiele.",
      ideasTitle: "Aufgabenideen von Pax AI",
      examplesTitle: "Beispiele für Aufgaben",
      ideasHint: "Wähl eine Tätigkeit. Antippen übernimmt die Idee ins Formular, dort kannst du sie anpassen.",
      more: "Neue Vorschläge",
      moreLoading: "Pax AI sucht neue Vorschläge …",
      show: "Einblenden",
      hide: "Einklappen",
    },
    collect: {
      // Startseite (Rueckmeldung 04.10.): es geht um das Team und seinen Alltag - ein gemeinsames Projekt; Ablauf in vier Bildern
      introTitle: "Umfrage zu den Aufgaben in eurem Team",
      introLead: "Wir sammeln, welche Aufgaben in eurem Team regelmäßig anfallen. Daraus entsteht das Grundgerüst für das kommende Task-Mining-Projekt, damit es sich an eurem echten Arbeitsalltag orientiert.",
      introToday: "Heute geht es nur um Schritt 1. Alles Weitere folgt später, gemeinsam mit deinem Team.",
      introCardLabel: "Heute",
      introCardTitle: "Sammle deine Aufgaben",
      introCardText: "In deinen eigenen Worten. Pax AI hilft auf Wunsch.",
      introTrustTeam: "Ausgewertet nur auf Teamebene",
      introTrustTogether: "Alles Weitere gemeinsam mit eurem Team",
      duration: "ca. 15 Minuten",
      title: "Welche Aufgaben gehören zu deinem Arbeitsalltag?",
      lead: "Danke, dass du dir Zeit nimmst! Wir möchten verstehen, welche Aufgaben in deinem Alltag anfallen und wie sie ablaufen. Zusammen mit den Angaben deines Teams grenzen wir ein, wo wir genauer hinschauen, um Abläufe zu erkennen und Verbesserungen und Automatisierungen vorzubereiten. Ausgewertet wird nur auf Teamebene.",
      leadMore: "Du brauchst keine Fachbegriffe. Beschreibe deine Arbeit einfach so, wie du sie einer Kollegin oder einem Kollegen erklären würdest. Denk dabei auch an kleine Routinen, Rückfragen und Aufgaben, die nur gelegentlich vorkommen.",
      areaTitle: "Damit die Vorschläge zu dir passen",
      area: "In welchem Bereich arbeitest du?",
      areaPlaceholder: "Zum Beispiel: Rechnungsprüfung, Kundenservice oder Einkauf",
      focus: "Was gehört zu deinem Arbeitsalltag?",
      focusPlaceholder: "Zum Beispiel: Rechnungen von Lieferanten, Rückfragen mit dem Einkauf, Zahlungsläufe",
      focusHelp: "Ein paar Stichworte reichen. Daraus macht Pax AI Vorschläge, aus denen du auswählst.",
      areaNote: "Wird nicht mit deinen Aufgaben übermittelt. Es dient nur den Aufgabenideen und deiner Übersicht.",
      exampleTitle: "So könnte eine Aufgabe aussehen",
      exampleHint: "Denk an eine konkrete Aufgabe mit einem erkennbaren Anfang und Ende. Deine Angaben kannst du später noch bearbeiten.",
      startCollect: "Weiter",
      title2: "Deine Aufgaben",
      lead2: "Trag hier nacheinander die Aufgaben ein, die du regelmäßig am Computer erledigst, jeweils mit Namen und kurzem Ablauf. Fang einfach mit der an, die dir als Erstes einfällt.",
      // Abfrage je Prozess (L1), wenn die Umfrage Prozesse vorgibt; zum Schluss "Sonstige Aufgaben"
      processTitle: (name) => `Welche Aufgaben fallen dir für „${name}“ ein?`,
      processLead: "Welche Aufgaben erledigst du in diesem Bereich regelmäßig am Computer? Trag sie jeweils mit Namen und kurzem Ablauf ein, am Ende ordnet Pax AI sie nach Themen. Fällt dir nichts ein, geh einfach weiter.",
      otherTitle: "Sonstige Aufgaben",
      otherLead: "Gibt es noch Aufgaben, die zu keinem der Bereiche passen? Trag sie hier ein.",
      processStep: (number, total) => `Bereich ${number} von ${total}`,
      areas: "Bereiche",
      areasIntro: (n) => (n === 1 ? "Eurem Team ist ein Bereich zugeordnet. Danach kannst du noch Sonstiges ergänzen." : `Eurem Team sind ${n} Bereiche zugeordnet. Wir gehen sie nacheinander durch, danach kannst du noch Sonstiges ergänzen.`),
      listIn: (name, count) => `Deine Aufgaben in „${name}“ (${count})`,
      otherStep: "Zum Schluss",
      nextProcess: (name) => `Weiter: ${name}`,
      collected: (count) => count === 1 ? "1 Aufgabe gesammelt" : `${count} Aufgaben gesammelt`,
      ideas: {
        areas: {
          create: "Erstellen & Anlegen",
          check: "Prüfen & Freigeben",
          book: "Buchen & Erfassen",
          maintain: "Ändern & Pflegen",
          incoming: "Eingänge bearbeiten",
          report: "Auswerten & Berichten",
        },
      },
      suggestions: "Schon im Team genannt. Antippen, wenn du das auch machst:",
      name: "Aufgabe",
      namePlaceholder: (name) => `z. B. ${name}`,
      // Sanfter Hinweis bei Werkzeugen statt Vorgaengen und bei Einzelwoertern - blockiert nichts
      channelWords: /^(e-?mails?|mails?|meetings?|besprechung|abstimmung|telefon|anrufe?|ablage|kommunikation|recherche|excel|sap|outlook|teams|dokumentation|organisation|sonstiges)/i,
      coachChannel: (word) => `„${word}“ ist eher ein Werkzeug als eine Aufgabe. Worum geht es dabei? Zum Beispiel „Lieferantenanfragen beantworten“.`,
      coachVerb: "Beschreib es am besten als Tätigkeit mit Gegenstand, z. B. „Rechnungen prüfen“ statt „Rechnungsprüfung“.",
      description: "Beschreibe kurz einen typischen Ablauf",
      descriptionHelp: "Ein kurzer Satz in deinen Worten reicht.",
      descriptionPlaceholder: (text) => `z. B. ${text}`,
      askDescription: "Magst du noch einen kurzen Satz zum Ablauf ergänzen? Sonst klick einfach noch einmal auf „Weiter“.",
      next: "Weiter",
      classifyFor: (name) => `Kurz einordnen: „${name}“`,
      classify: "Kurz einordnen",
      classifyHint: "ein Klick je Frage",
      weights: { 5: "Kleiner Teil", 15: "Ein guter Teil", 30: "Großer Teil" },
      frequency: "Wie oft?",
      taskDuration: "Wie lange dauert sie einmal?",
      digital: "Am Computer?",
      continuity: "Von einer Person am Stück?",
      standardization: "Läuft sie meist gleich ab?",
      add: "Aufgabe übernehmen",
      update: "Änderung übernehmen",
      cancelEdit: "Abbrechen",
      missing: (n) => (n === 1 ? "Noch eine Angabe fehlt" : `Noch ${n} Angaben fehlen`),
      list: (count) => `Deine Liste (${count})`,
      empty: "Noch keine Aufgabe. Die meisten nennen 4 bis 8.",
      edit: "Bearbeiten",
      remove: "Entfernen",
      removeTitle: "Aufgabe entfernen?",
      removeText: (name) => `„${name}“ wird aus deiner Liste entfernt.`,
      pendingForm: "Die Aufgabe im Formular ist noch nicht übernommen. Erst übernehmen oder leeren.",
      review: "Aufgaben prüfen",
      reviewTitle: "Passt deine Aufgabenübersicht?",
      reviewLead: "Prüfe deine Angaben. Du kannst Aufgaben bearbeiten, entfernen oder weitere ergänzen.",
      noTasksReview: "Du hast keine Aufgabe eingetragen. Wenn das so passt, schick die Umfrage trotzdem ab, auch das hilft uns weiter.",
      reviewMore: "Fehlt noch eine Aufgabe? Vielleicht eine, die nur ab und zu vorkommt?",
      reviewGrouping: "Pax AI ordnet deine Aufgaben nach Themen …",
      reviewOther: "Weitere Aufgaben",
      periodTitle: "Kommt die Aufgabe in der Erhebungsphase vor?",
      periodLabel: "Erhebungsphase",
      periodRange: (from, until) => `${from} bis ${until}`,
      periodHint: "Ja oder Nein hilft bei der Planung des Projekts. Aufgaben mit „Nein“ bleiben einfach auf der Liste. Sie sind für später genauso wertvoll.",
      periodOpen: (count) => `Bei ${count === 1 ? "einer Aufgabe fehlt" : `${count} Aufgaben fehlt`} noch Ja oder Nein zur Erhebungsphase. Magst du das ergänzen? Sonst klick einfach noch einmal auf „Aufgaben absenden“.`,
      inPeriod: "In der Erhebungsphase?",
      addAnother: "Weitere Aufgabe ergänzen",
      submit: "Aufgaben absenden",
      submitting: "Wird gesendet …",
      sentTitle: "Danke! Deine Aufgaben wurden übermittelt",
      sentText: "Zusammen mit den Angaben deines Teams zeigen sie uns, wo wir genauer hinschauen.",
      sentChange: (date) => `Bis ${date} kannst du über diesen Link noch etwas ändern.`,
      sentEdit: "Aufgaben bearbeiten",
    },
    select: {
      duration: "ca. 2 Minuten",
      title: "Welche Aufgaben schauen wir uns genauer an?",
      lead: (tasks, themes) => `Ihr habt eure Aufgaben genannt, gleiche Aufgaben haben wir zusammengefasst: ${tasks} ${tasks === 1 ? "Aufgabe" : "Aufgaben"} in ${themes} ${themes === 1 ? "Thema" : "Themen"}.`,
      how: "Bei jeder Aufgabe ist schon eine Empfehlung gesetzt. Ändere nur, wo du anderer Meinung bist.",
      leadFramework: (tasks, themes) => `Diese Aufgaben stehen schon im Framework eures Bereichs: ${tasks} ${tasks === 1 ? "Aufgabe" : "Aufgaben"} in ${themes} ${themes === 1 ? "Thema" : "Themen"}.`,
      howFramework: "Alle sind auf „Ja“ gesetzt. Stell auf „Nein“, was nicht genauer angeschaut werden soll.",
      meaning: "„Ja“ heißt: Diese Aufgabe wird im Task Mining genauer betrachtet.",
      criteria: "Empfohlen heißt:",
      criteriaList: ["überwiegend am Computer", "von einer Person am Stück erledigt", "kommt regelmäßig vor"],
      title2: "Gemeinsam auswählen",
      filters: { all: "Alle", suitable: "Empfohlen", not_suitable: "Eher nicht", unclear: "Unklar" },
      mentions: (count) => `${count}× genannt`,
      inPeriod: (yes, no) => `in der Erhebung: ${yes}× ja, ${no}× nein`,
      share: (percent) => ({ 5: "Kleiner Teil der Arbeit", 15: "Ein guter Teil der Arbeit", 30: "Großer Teil der Arbeit" })[weightOf(percent)],
      question: "Genauer anschauen?",
      yes: "Ja",
      no: "Nein",
      comment: "Kommentar",
      commentPlaceholder: "Optional: warum?",
      missing: "Fehlt eine wichtige Aufgabe?",
      addMissing: "Aufgabe ergänzen",
      addAnother: "Weitere Aufgabe ergänzen",
      changed: (count) => count === 0 ? "Du hast alle Empfehlungen übernommen." : count === 1 ? "Du hast 1 Empfehlung geändert." : `Du hast ${count} Empfehlungen geändert.`,
      submit: "Fertig: Auswahl absenden",
      sentTitle: "Danke, deine Auswahl ist angekommen!",
      sentText: (date) => `Bis ${date} kannst du sie über diesen Link noch ändern.`,
      sentEdit: "Auswahl bearbeiten",
    },
    done: {
      title: "Die Auswahl steht",
      lead: "Diese Aufgaben schaut sich das Projektteam jetzt genauer an. Danke fürs Mitmachen!",
      titleCollect: "Eure Aufgabenliste steht",
      leadCollect: "Diese Aufgaben hat euer Team genannt. Das Projektteam macht daraus das Framework. Danke fürs Mitmachen!",
      votes: (yes, no) => `${yes} Ja · ${no} Nein`,
      notSelected: "Nicht ausgewählt",
    },
    status: { suitable: "Empfohlen", not_suitable: "Eher nicht relevant", unclear: "Keine klare Einschätzung", framework: "Aus dem Framework" },
    reasons: {
      fits: "am Computer, am Stück, regelmäßig",
      offline: "überwiegend ohne Computer",
      several_people: "mehrere Personen beteiligt",
      disputed: "unterschiedliche Angaben im Team",
      unknown: "zu wenige Angaben",
      partly_digital: "nur teilweise am Computer",
      interrupted: "mit Übergaben oder Warten",
      rare: "kommt selten vor",
      variable: "läuft jedes Mal anders",
      too_short: "eher ein einzelner Schritt",
      framework: "keine Angaben aus dem Team",
    },
    values: {
      "Mainly digital": "Überwiegend",
      "Partly digital": "Teilweise",
      "Mainly offline": "Kaum",
      "Yes": "Ja",
      "Partly, with handoffs or waiting": "Mit Übergaben oder Warten",
      "No": "Nein, mehrere Personen",
      "Daily": "Täglich",
      "Weekly": "Wöchentlich",
      "Monthly": "Monatlich",
      "Yearly or less often": "Seltener",
      "Mostly consistent": "Meist gleich",
      "Some variation": "Etwas unterschiedlich",
      "Highly variable": "Jedes Mal anders",
      "Under 5 minutes": "Unter 5 Min.",
      "5-30 minutes": "5 bis 30 Min.",
      "30-60 minutes": "30 Min. bis 1 Std.",
      "Over 1 hour": "Über 1 Std.",
    },
    facts: {
      "Mainly digital": "am Computer",
      "Partly digital": "teils am Computer",
      "Mainly offline": "kaum am Computer",
      "Yes": "am Stück",
      "Partly, with handoffs or waiting": "mit Übergaben",
      "No": "mehrere Personen",
      "Mostly consistent": "meist gleich",
      "Some variation": "mit Varianten",
      "Highly variable": "jedes Mal anders",
    },
  },
  en: {
    locale: "en-GB",
    // Schrittanzeige oben rechts wie im Framework Assistant
    steps: { collect: ["Start", "Pax AI", "Tasks", "Review"], select: ["Start", "Choose"] },
    lightMode: "Light",
    darkMode: "Dark",
    product: "Task Mining",
    area: "Team survey",
    stepOf: (step, total) => `Step ${step} of ${total}`,
    duration: "Time",
    anonymous: "Anonymous: nobody can see who entered what.",
    openUntil: (date) => `Open until ${date}`,
    lateOpen: "The deadline has passed. You can still take part.",
    notFound: "This survey does not exist (anymore). Please check the link or ask your project team.",
    preparing: "The shared list is being put together …",
    preparingHint: "This usually takes less than a minute. The page refreshes by itself.",
    saveError: "Saving did not work. Please try again in a moment.",
    stageChanged: "Collecting has ended in the meantime. Now it is time to choose together.",
    stageChangedSent: "Thanks, your tasks are in! All answers have been merged. Now it is time to choose together.",
    draftSaved: "Progress saved",
    draftSavedEverywhere: "Progress saved. You can also continue on another device",
    alreadySent: "You have already sent your answers, probably on another device. Thanks for taking part!",
    back: "Back",
    start: "Let's go",
    optional: "optional",
    departmentLabel: "Department",
    assist: {
      title: "Would you like support in collecting your tasks?",
      lead: "Pax AI can suggest task ideas based on your answers. You decide which of them fit your work, and you can adjust them.",
      yes: "Yes, show me ideas",
      no: "No, I'll write myself",
      loading: "Pax AI is putting together task ideas …",
      error: "Task ideas for your area are not available right now. Here are general examples.",
      ideasTitle: "Task ideas from Pax AI",
      examplesTitle: "Example tasks",
      ideasHint: "Choose an activity. Tapping puts the idea into the form, you can adjust it there.",
      more: "New suggestions",
      moreLoading: "Pax AI is finding new suggestions …",
      show: "Show",
      hide: "Collapse",
    },
    collect: {
      // Startseite (Rueckmeldung 04.10.): es geht um das Team und seinen Alltag - ein gemeinsames Projekt; Ablauf in vier Bildern
      introTitle: "Survey on the tasks in your team",
      introLead: "We are collecting the tasks that come up regularly in your team. They form the basic structure for the upcoming task mining project, so that it reflects how you really work.",
      introToday: "Today is only about step 1. Everything else follows later, together with your team.",
      introCardLabel: "Today",
      introCardTitle: "Collect your tasks",
      introCardText: "In your own words. Pax AI helps if you like.",
      introTrustTeam: "Evaluated only at team level",
      introTrustTogether: "Everything else together with your team",
      duration: "about 15 minutes",
      title: "Which tasks are part of your daily work?",
      lead: "Thank you for taking the time! We want to understand which tasks come up in your daily work and how they run. Together with your team's answers, we narrow down where to take a closer look, to recognise workflows and prepare improvements and automation. Results are only evaluated at team level.",
      leadMore: "You don't need any technical terms. Simply describe your work the way you would explain it to a colleague. Also think of small routines, follow-up questions and tasks that only come up occasionally.",
      areaTitle: "So the suggestions fit you",
      area: "Which area do you work in?",
      areaPlaceholder: "For example: invoice checking, customer service or purchasing",
      focus: "What is part of your working day?",
      focusPlaceholder: "For example: supplier invoices, questions from purchasing, payment runs",
      focusHelp: "A few keywords are enough. Pax AI turns them into suggestions you can choose from.",
      areaNote: "Not sent with your tasks. It only serves the task ideas and your overview.",
      exampleTitle: "What a task could look like",
      exampleHint: "Think of a concrete task with a recognisable start and end. You can still edit your answers later.",
      startCollect: "Next",
      title2: "Your tasks",
      lead2: "Enter the tasks you regularly do at the computer, one after the other, each with a name and a short description. Just start with the first one that comes to mind.",
      processTitle: (name) => `Which tasks come to mind for “${name}”?`,
      processLead: "Which tasks do you regularly do at the computer in this area? Enter each with a name and a short description; at the end, Pax AI sorts them by theme. If nothing comes to mind, just continue.",
      otherTitle: "Other tasks",
      otherLead: "Are there tasks that fit none of the areas? Add them here.",
      processStep: (number, total) => `Area ${number} of ${total}`,
      areas: "Areas",
      areasIntro: (n) => (n === 1 ? "One area is assigned to your team. Afterwards you can add anything else." : `${n} areas are assigned to your team. We go through them one by one, then you can add anything else.`),
      listIn: (name, count) => `Your tasks in “${name}” (${count})`,
      otherStep: "Finally",
      nextProcess: (name) => `Next: ${name}`,
      collected: (count) => count === 1 ? "1 task collected" : `${count} tasks collected`,
      ideas: {
        areas: {
          create: "Create",
          check: "Review & approve",
          book: "Post & enter",
          maintain: "Change & maintain",
          incoming: "Incoming cases",
          report: "Analyse & report",
        },
      },
      suggestions: "Already named in your team. Tap if you do this too:",
      name: "Task",
      namePlaceholder: (name) => `e.g. ${name}`,
      channelWords: /^(e-?mails?|mails?|meetings?|calls?|phone|filing|communication|research|excel|sap|outlook|teams|documentation|admin|organi[sz]ation|misc)/i,
      coachChannel: (word) => `“${word}” is more of a tool than a task. What is it about? For example “Answer supplier questions”.`,
      coachVerb: "Ideally describe it as an activity with an object, e.g. “Review invoices” rather than “Invoice review”.",
      description: "Briefly describe a typical run",
      descriptionHelp: "A short sentence in your own words is enough.",
      descriptionPlaceholder: (text) => `e.g. ${text}`,
      askDescription: "Would you add one short sentence about how it runs? Otherwise just click “Next” again.",
      next: "Next",
      classifyFor: (name) => `Classify briefly: “${name}”`,
      classify: "Classify briefly",
      classifyHint: "one click per question",
      weights: { 5: "Small part", 15: "A fair part", 30: "Large part" },
      frequency: "How often?",
      taskDuration: "How long does it take once?",
      digital: "At the computer?",
      continuity: "Done by one person in one go?",
      standardization: "Is it usually done the same way?",
      add: "Add task",
      update: "Save changes",
      cancelEdit: "Cancel",
      missing: (n) => (n === 1 ? "One answer is still missing" : `${n} answers are still missing`),
      list: (count) => `Your list (${count})`,
      empty: "No task yet. Most people name 4 to 8.",
      edit: "Edit",
      remove: "Remove",
      removeTitle: "Remove task?",
      removeText: (name) => `“${name}” will be removed from your list.`,
      pendingForm: "The task in the form has not been added yet. Add it or clear it first.",
      review: "Review tasks",
      reviewTitle: "Does your task overview fit?",
      reviewLead: "Check your answers. You can edit, remove or add tasks.",
      noTasksReview: "You have not entered any task. If that is right, send the survey anyway, that helps us too.",
      reviewMore: "Is a task missing? Maybe one that only comes up now and then?",
      reviewGrouping: "Pax AI is sorting your tasks by theme …",
      reviewOther: "Other tasks",
      periodTitle: "Does the task occur during the data collection phase?",
      periodLabel: "Data collection phase",
      periodRange: (from, until) => `${from} to ${until}`,
      periodHint: "Yes or No helps plan the project. Tasks with “No” simply stay on the list. They are just as valuable later.",
      periodOpen: (count) => `${count === 1 ? "One task still needs" : `${count} tasks still need`} a Yes or No for the collection period. Could you add it? Otherwise just click “Send tasks” again.`,
      inPeriod: "In the data collection phase?",
      addAnother: "Add another task",
      submit: "Send tasks",
      submitting: "Sending …",
      sentTitle: "Thank you! Your tasks have been sent",
      sentText: "Together with your team's answers they show us where to take a closer look.",
      sentChange: (date) => `Until ${date} you can still make changes via this link.`,
      sentEdit: "Edit tasks",
    },
    select: {
      duration: "about 2 minutes",
      title: "Which tasks should we look at more closely?",
      lead: (tasks, themes) => `You named your tasks and we merged identical ones: ${tasks} ${tasks === 1 ? "task" : "tasks"} in ${themes} ${themes === 1 ? "theme" : "themes"}.`,
      how: "Every task already has a recommendation. Only change it where you disagree.",
      leadFramework: (tasks, themes) => `These tasks are already in the framework of your area: ${tasks} ${tasks === 1 ? "task" : "tasks"} in ${themes} ${themes === 1 ? "theme" : "themes"}.`,
      howFramework: "All are set to “Yes”. Switch to “No” what should not be looked at more closely.",
      meaning: "“Yes” means: this task will be looked at more closely in Task Mining.",
      criteria: "Recommended means:",
      criteriaList: ["mostly at the computer", "done by one person in one go", "happens regularly"],
      title2: "Choose together",
      filters: { all: "All", suitable: "Recommended", not_suitable: "Rather not", unclear: "Unclear" },
      mentions: (count) => `named ${count}×`,
      inPeriod: (yes, no) => `in data collection: ${yes}× yes, ${no}× no`,
      share: (percent) => ({ 5: "Small part of the work", 15: "A fair part of the work", 30: "Large part of the work" })[weightOf(percent)],
      question: "Look at it more closely?",
      yes: "Yes",
      no: "No",
      comment: "Comment",
      commentPlaceholder: "Optional: why?",
      missing: "Is an important task missing?",
      addMissing: "Add task",
      addAnother: "Add another task",
      changed: (count) => count === 0 ? "You kept all recommendations." : count === 1 ? "You changed 1 recommendation." : `You changed ${count} recommendations.`,
      submit: "Done: send selection",
      sentTitle: "Thank you, your selection has arrived!",
      sentText: (date) => `Until ${date} you can still change it via this link.`,
      sentEdit: "Edit selection",
    },
    done: {
      title: "The selection is complete",
      lead: "The project team will now look at these tasks more closely. Thanks for taking part!",
      titleCollect: "Your task list is complete",
      leadCollect: "These are the tasks your team named. The project team builds the framework from them. Thanks for taking part!",
      votes: (yes, no) => `${yes} yes · ${no} no`,
      notSelected: "Not selected",
    },
    status: { suitable: "Recommended", not_suitable: "Rather not relevant", unclear: "No clear assessment", framework: "From the framework" },
    reasons: {
      fits: "at the computer, in one go, regularly",
      offline: "mostly without a computer",
      several_people: "several people involved",
      disputed: "different answers in the team",
      unknown: "too few answers",
      partly_digital: "only partly at the computer",
      interrupted: "with handoffs or waiting",
      rare: "happens rarely",
      variable: "different every time",
      too_short: "rather a single step",
      framework: "no details from the team",
    },
    values: {
      "Mainly digital": "Mostly",
      "Partly digital": "Partly",
      "Mainly offline": "Hardly",
      "Yes": "Yes",
      "Partly, with handoffs or waiting": "With handoffs or waiting",
      "No": "No, several people",
      "Daily": "Daily",
      "Weekly": "Weekly",
      "Monthly": "Monthly",
      "Yearly or less often": "Less often",
      "Mostly consistent": "Mostly the same",
      "Some variation": "Some variation",
      "Highly variable": "Different every time",
      "Under 5 minutes": "Under 5 min",
      "5-30 minutes": "5 to 30 min",
      "30-60 minutes": "30 min to 1 h",
      "Over 1 hour": "Over 1 h",
    },
    facts: {
      "Mainly digital": "at the computer",
      "Partly digital": "partly at the computer",
      "Mainly offline": "hardly at the computer",
      "Yes": "in one go",
      "Partly, with handoffs or waiting": "with handoffs",
      "No": "several people",
      "Mostly consistent": "mostly the same",
      "Some variation": "with variants",
      "Highly variable": "different every time",
    },
  },
  fr: {
      locale: "fr-FR",
      // Schrittanzeige oben rechts wie im Framework Assistant
      steps: { collect: ["Début", "Pax AI", "Tâches", "Vérifier"], select: ["Début", "Choisir"] },
      lightMode: "Clair",
      darkMode: "Sombre",
      product: "Task Mining",
      area: "Enquête d'équipe",
      stepOf: (step, total) => `Étape ${step} sur ${total}`,
      duration: "Durée",
      anonymous: "Anonyme : personne ne voit qui a saisi quoi.",
      openUntil: (date) => `Ouverte jusqu'au ${date}`,
      lateOpen: "Le délai est passé. Tu peux quand même encore participer.",
      notFound: "Cette enquête n'existe pas (ou plus). Vérifie le lien ou demande à l'équipe projet.",
      preparing: "La liste commune est en cours de préparation …",
      preparingHint: "Cela prend en général moins d'une minute. La page s'actualise toute seule.",
      saveError: "L'enregistrement n'a pas fonctionné. Réessaie dans un instant.",
      stageChanged: "La phase de collecte est terminée entre-temps. Place maintenant au choix commun.",
      stageChangedSent: "Merci, tes tâches sont bien arrivées ! Toutes les réponses ont été regroupées. Place maintenant au choix commun.",
      draftSaved: "Progression enregistrée",
      draftSavedEverywhere: "Progression enregistrée. Tu peux aussi continuer sur un autre appareil",
      alreadySent: "Tu as déjà envoyé tes réponses, sans doute sur un autre appareil. Merci de ta participation !",
      back: "Retour",
      start: "C'est parti",
      optional: "facultatif",
      departmentLabel: "Service",
      assist: {
        title: "Veux-tu de l'aide pour rassembler tes tâches ?",
        lead: "Pax AI peut te proposer des idées de tâches à partir de tes réponses. C'est toi qui décides lesquelles correspondent à ton travail, et tu peux les adapter.",
        yes: "Oui, montre-moi des idées",
        no: "Non, j’écris moi-même",
        loading: "Pax AI prépare des idées de tâches …",
        error: "Les idées de tâches pour ton domaine ne sont pas disponibles pour le moment. Voici des exemples généraux.",
        ideasTitle: "Idées de tâches de Pax AI",
        examplesTitle: "Exemples de tâches",
        ideasHint: "Choisis une activité. En la sélectionnant, tu reprends l'idée dans le formulaire, où tu peux l'adapter.",
        more: "Nouvelles propositions",
        moreLoading: "Pax AI cherche de nouvelles propositions …",
        show: "Afficher",
        hide: "Réduire",
      },
      collect: {
        // Startseite (Rueckmeldung 04.10.): es geht um das Team und seinen Alltag - ein gemeinsames Projekt; Ablauf in vier Bildern
        introTitle: "Enquête sur les tâches de votre équipe",
        introLead: "Nous recueillons les tâches qui reviennent régulièrement dans votre équipe. Elles forment la structure de base du futur projet de task mining, pour qu’il reflète votre travail réel.",
        introToday: "Aujourd’hui, il s’agit uniquement de l’étape 1. La suite viendra plus tard, avec ton équipe.",
        introCardLabel: "Aujourd’hui",
        introCardTitle: "Rassemble tes tâches",
        introCardText: "Avec tes propres mots. Pax AI t’aide si tu le souhaites.",
        introTrustTeam: "Analysé uniquement au niveau de l’équipe",
        introTrustTogether: "La suite, ensemble avec ton équipe",
        duration: "env. 15 minutes",
        title: "Quelles tâches font partie de ton quotidien au travail ?",
        lead: "Merci de prendre le temps ! Nous voulons comprendre quelles tâches reviennent dans ton quotidien et comment elles se déroulent. Avec les réponses de ton équipe, nous délimitons où regarder de plus près, pour repérer les processus et préparer des améliorations et de l'automatisation. L'analyse se fait uniquement au niveau de l'équipe.",
        leadMore: "Pas besoin de termes techniques. Décris simplement ton travail comme tu l'expliquerais à un ou une collègue. Pense aussi aux petites routines, aux questions à clarifier et aux tâches qui ne reviennent que de temps en temps.",
        areaTitle: "Pour que les propositions te correspondent",
        area: "Dans quel domaine travailles-tu ?",
        areaPlaceholder: "Par exemple : contrôle des factures, service client ou achats",
        focus: "Qu’est-ce qui fait partie de ton quotidien ?",
        focusPlaceholder: "Par exemple : factures fournisseurs, questions des achats, lots de paiement",
        focusHelp: "Quelques mots-clés suffisent. Pax AI en tire des propositions parmi lesquelles tu choisis.",
        areaNote: "N'est pas transmis avec tes tâches, il sert uniquement aux idées de tâches et à ta vue d'ensemble.",
        exampleTitle: "Voici à quoi pourrait ressembler une tâche",
        exampleHint: "Pense à une tâche concrète avec un début et une fin bien reconnaissables. Tu pourras encore modifier tes réponses plus tard.",
        startCollect: "Suivant",
        title2: "Tes tâches",
        lead2: "Saisis ici, l'une après l'autre, les tâches que tu fais régulièrement sur l'ordinateur, chacune avec un nom et un court déroulement. Commence simplement par la première qui te vient à l'esprit.",
        processTitle: (name) => `Quelles tâches te viennent à l'esprit pour « ${name} » ?`,
        processLead: "Quelles tâches fais-tu régulièrement sur l'ordinateur dans ce domaine ? Saisis-les chacune avec un nom et un court déroulement ; à la fin, Pax AI les classe par thème. Si rien ne te vient, continue simplement.",
        otherTitle: "Autres tâches",
        otherLead: "Y a-t-il des tâches qui ne correspondent à aucun domaine ? Ajoute-les ici.",
        processStep: (number, total) => `Domaine ${number} sur ${total}`,
        areas: "Domaines",
        areasIntro: (n) => (n === 1 ? "Un domaine est attribué à votre équipe. Ensuite, tu peux ajouter d'autres tâches." : `${n} domaines sont attribués à votre équipe. Nous les parcourons un par un, puis tu peux ajouter d'autres tâches.`),
        listIn: (name, count) => `Tes tâches dans « ${name} » (${count})`,
        otherStep: "Pour finir",
        nextProcess: (name) => `Suivant : ${name}`,
        collected: (count) => count <= 1 ? `${count} tâche collectée` : `${count} tâches collectées`,
        ideas: {
          areas: {
            create: "Créer",
            check: "Vérifier et valider",
            book: "Comptabiliser et saisir",
            maintain: "Modifier et mettre à jour",
            incoming: "Traiter les demandes entrantes",
            report: "Analyser et rendre compte",
          },
        },
        suggestions: "Déjà citées dans ton équipe : sélectionne celles que tu fais aussi :",
        name: "Tâche",
        namePlaceholder: (name) => `p. ex. ${name}`,
        channelWords: /^(e-?mails?|mails?|courriels?|r[ée]unions?|meetings?|appels?|t[ée]l[ée]phone|classement|communication|recherches?|excel|sap|outlook|teams|documentation|admin|organisation|divers)/i,
        coachChannel: (word) => `« ${word} » est plutôt un outil qu'une tâche. De quoi s'agit-il ? Par exemple « Répondre aux questions des fournisseurs ».`,
        coachVerb: "Décris-la plutôt comme une activité avec un objet, p. ex. « Vérifier les factures » au lieu de « Vérification des factures ».",
        description: "Décris brièvement un déroulement typique",
        descriptionHelp: "Une courte phrase avec tes mots suffit.",
        descriptionPlaceholder: (text) => `p. ex. ${text}`,
        askDescription: "Tu veux ajouter une courte phrase sur le déroulement ? Sinon, clique simplement encore une fois sur « Suivant ».",
        next: "Suivant",
        classifyFor: (name) => `Classer rapidement : « ${name} »`,
        classify: "Classer rapidement",
        classifyHint: "un clic par question",
        weights: { 5: "Petite partie", 15: "Une bonne partie", 30: "Grande partie" },
        frequency: "À quelle fréquence ?",
        taskDuration: "Combien de temps dure-t-elle une fois ?",
        digital: "Sur l'ordinateur ?",
        continuity: "Par une seule personne, d'une traite ?",
        standardization: "Se déroule-t-elle en général de la même façon ?",
        add: "Ajouter la tâche",
        update: "Enregistrer les modifications",
        cancelEdit: "Annuler",
        missing: (n) => (n === 1 ? "Il manque encore une réponse" : `Il manque encore ${n} réponses`),
        list: (count) => `Ta liste (${count})`,
        empty: "Aucune tâche pour l'instant. La plupart en citent 4 à 8.",
        edit: "Modifier",
        remove: "Supprimer",
        removeTitle: "Supprimer la tâche ?",
        removeText: (name) => `« ${name} » sera retirée de ta liste.`,
        pendingForm: "La tâche du formulaire n'a pas encore été ajoutée. Ajoute-la ou vide le formulaire d'abord.",
        review: "Vérifier les tâches",
        reviewTitle: "Ta liste de tâches te convient-elle ?",
        reviewLead: "Vérifie tes réponses. Tu peux modifier, supprimer ou ajouter des tâches.",
        noTasksReview: "Tu n'as saisi aucune tâche. Si c'est correct, envoie quand même l'enquête, cela nous aide aussi.",
        reviewMore: "Il manque une tâche ? Peut-être une qui ne revient que de temps en temps ?",
        reviewGrouping: "Pax AI classe tes tâches par thème …",
        reviewOther: "Autres tâches",
        periodTitle: "La tâche a-t-elle lieu pendant la phase de collecte ?",
        periodLabel: "Phase de collecte",
        periodRange: (from, until) => `du ${from} au ${until}`,
        periodHint: "Oui ou Non aide à planifier le projet. Les tâches marquées « Non » restent simplement sur la liste. Elles seront tout aussi utiles plus tard.",
        periodOpen: (count) => `${count <= 1 ? "Une tâche n’a" : `${count} tâches n’ont`} pas encore de Oui ou de Non pour la période de collecte. Tu peux compléter ? Sinon, clique encore une fois sur « Envoyer les tâches ».`,
        inPeriod: "Pendant la phase de collecte ?",
        addAnother: "Ajouter une autre tâche",
        submit: "Envoyer les tâches",
        submitting: "Envoi en cours …",
        sentTitle: "Merci ! Tes tâches ont été envoyées",
        sentText: "Avec les réponses de ton équipe, elles nous montrent où regarder de plus près.",
        sentChange: (date) => `Jusqu'au ${date}, tu peux encore faire des modifications via ce lien.`,
        sentEdit: "Modifier les tâches",
      },
      select: {
        duration: "env. 2 minutes",
        title: "Quelles tâches regardons-nous de plus près ?",
        lead: (tasks, themes) => `Vous avez cité vos tâches et nous avons regroupé celles qui sont identiques : ${tasks} ${tasks <= 1 ? "tâche" : "tâches"} dans ${themes} ${themes <= 1 ? "thème" : "thèmes"}.`,
        how: "Chaque tâche a déjà une recommandation. Ne la change que si tu n'es pas d'accord.",
        leadFramework: (tasks, themes) => `Ces tâches figurent déjà dans le framework de votre domaine : ${tasks} ${tasks <= 1 ? "tâche" : "tâches"} dans ${themes} ${themes <= 1 ? "thème" : "thèmes"}.`,
        howFramework: "Toutes sont sur « Oui ». Passe sur « Non » ce qui ne doit pas être regardé de plus près.",
        meaning: "« Oui » signifie : cette tâche sera examinée de plus près dans le Task Mining.",
        criteria: "Recommandé signifie :",
        criteriaList: ["surtout sur l'ordinateur", "faite par une seule personne, d'une traite", "revient régulièrement"],
        title2: "Choisir ensemble",
        filters: { all: "Toutes", suitable: "Recommandées", not_suitable: "Plutôt non", unclear: "Incertaines" },
        mentions: (count) => `citée ${count}×`,
        inPeriod: (yes, no) => `pendant la collecte : ${yes}× oui, ${no}× non`,
        share: (percent) => ({ 5: "Petite partie du travail", 15: "Une bonne partie du travail", 30: "Grande partie du travail" })[weightOf(percent)],
        question: "La regarder de plus près ?",
        yes: "Oui",
        no: "Non",
        comment: "Commentaire",
        commentPlaceholder: "Facultatif : pourquoi ?",
        missing: "Il manque une tâche importante ?",
        addMissing: "Ajouter une tâche",
        addAnother: "Ajouter une autre tâche",
        changed: (count) => count === 0 ? "Tu as gardé toutes les recommandations." : count === 1 ? "Tu as modifié 1 recommandation." : `Tu as modifié ${count} recommandations.`,
        submit: "Terminé : envoyer la sélection",
        sentTitle: "Merci, ta sélection est bien arrivée !",
        sentText: (date) => `Jusqu'au ${date}, tu peux encore la modifier via ce lien.`,
        sentEdit: "Modifier la sélection",
      },
      done: {
        title: "La sélection est faite",
        lead: "L'équipe projet va maintenant regarder ces tâches de plus près. Merci de ta participation !",
        titleCollect: "Votre liste de tâches est prête",
        leadCollect: "Voici les tâches citées par votre équipe. L'équipe projet en fait le framework. Merci de ta participation !",
        votes: (yes, no) => `${yes} oui · ${no} non`,
        notSelected: "Non sélectionnée",
      },
      status: { suitable: "Recommandée", not_suitable: "Plutôt pas pertinente", unclear: "Pas d'avis clair", framework: "Issue du framework" },
      reasons: {
        fits: "sur l'ordinateur, d'une traite, régulièrement",
        offline: "surtout sans ordinateur",
        several_people: "plusieurs personnes impliquées",
        disputed: "réponses différentes dans l'équipe",
        unknown: "trop peu de réponses",
        partly_digital: "seulement en partie sur l'ordinateur",
        interrupted: "avec des passages de relais ou de l'attente",
        rare: "revient rarement",
        variable: "différente à chaque fois",
        too_short: "plutôt une seule étape",
        framework: "pas de réponses de l'équipe",
      },
      values: {
        "Mainly digital": "Surtout",
        "Partly digital": "En partie",
        "Mainly offline": "Presque pas",
        "Yes": "Oui",
        "Partly, with handoffs or waiting": "Avec passages de relais ou attente",
        "No": "Non, plusieurs personnes",
        "Daily": "Tous les jours",
        "Weekly": "Toutes les semaines",
        "Monthly": "Tous les mois",
        "Yearly or less often": "Plus rarement",
        "Mostly consistent": "Presque toujours pareil",
        "Some variation": "Un peu variable",
        "Highly variable": "Différent à chaque fois",
        "Under 5 minutes": "Moins de 5 min",
        "5-30 minutes": "5 à 30 min",
        "30-60 minutes": "30 min à 1 h",
        "Over 1 hour": "Plus d'1 h",
      },
      facts: {
        "Mainly digital": "sur l'ordinateur",
        "Partly digital": "en partie sur l'ordinateur",
        "Mainly offline": "presque pas sur l'ordinateur",
        "Yes": "d'une traite",
        "Partly, with handoffs or waiting": "avec passages de relais",
        "No": "plusieurs personnes",
        "Mostly consistent": "presque toujours pareil",
        "Some variation": "avec des variantes",
        "Highly variable": "différent à chaque fois",
      },
    },
  it: {
    locale: "it-IT",
    // Schrittanzeige oben rechts wie im Framework Assistant
    steps: { collect: ["Inizio", "Pax AI", "Attività", "Verifica"], select: ["Inizio", "Scegliere"] },
    lightMode: "Chiaro",
    darkMode: "Scuro",
    product: "Task Mining",
    area: "Sondaggio del team",
    stepOf: (step, total) => `Passo ${step} di ${total}`,
    duration: "Durata",
    anonymous: "Anonimo: nessuno vede chi ha scritto cosa.",
    openUntil: (date) => `Scadenza: ${date}`,
    lateOpen: "La scadenza è passata. Puoi partecipare lo stesso.",
    notFound: "Questo sondaggio non esiste (più). Controlla il link o chiedi al team di progetto.",
    preparing: "Stiamo preparando la lista comune …",
    preparingHint: "Di solito ci vuole meno di un minuto. La pagina si aggiorna da sola.",
    saveError: "Il salvataggio non è riuscito. Riprova tra un attimo.",
    stageChanged: "Nel frattempo la raccolta è finita. Ora si sceglie insieme.",
    stageChangedSent: "Grazie, le tue attività ci sono! Abbiamo riunito tutte le risposte. Ora si sceglie insieme.",
    draftSaved: "Bozza salvata",
    draftSavedEverywhere: "Bozza salvata. Puoi continuare anche su un altro dispositivo",
    alreadySent: "Hai già inviato le risposte, probabilmente da un altro dispositivo. Grazie per aver partecipato!",
    back: "Indietro",
    start: "Iniziamo",
    optional: "facoltativo",
    departmentLabel: "Reparto",
    assist: {
      title: "Vuoi un aiuto per raccogliere le tue attività?",
      lead: "Pax AI può suggerirti idee di attività in base alle tue risposte. Sei tu a decidere quali vanno bene per il tuo lavoro, e puoi modificarle.",
      yes: "Sì, mostrami delle idee",
      no: "No, scrivo io",
      loading: "Pax AI sta preparando idee di attività …",
      error: "Al momento non ci sono idee per il tuo settore. Ecco alcuni esempi generali.",
      ideasTitle: "Idee di attività da Pax AI",
      examplesTitle: "Esempi di attività",
      ideasHint: "Scegli un'attività. Toccandola, l'idea passa nel modulo, dove puoi modificarla.",
      more: "Nuove proposte",
      moreLoading: "Pax AI cerca nuove proposte …",
      show: "Mostra",
      hide: "Comprimi",
    },
    collect: {
      // Startseite (Rueckmeldung 04.10.): es geht um das Team und seinen Alltag - ein gemeinsames Projekt; Ablauf in vier Bildern
      introTitle: "Sondaggio sulle attività del vostro team",
      introLead: "Raccogliamo le attività che si ripetono regolarmente nel vostro team. Da qui nasce la struttura di base del prossimo progetto di task mining, perché rispecchi il vostro lavoro reale.",
      introToday: "Oggi si tratta solo del passo 1. Il resto seguirà più avanti, insieme al tuo team.",
      introCardLabel: "Oggi",
      introCardTitle: "Raccogli le tue attività",
      introCardText: "Con parole tue. Se vuoi, Pax AI ti aiuta.",
      introTrustTeam: "Analizzato solo a livello di team",
      introTrustTogether: "Il resto, insieme al tuo team",
      duration: "circa 15 minuti",
      title: "Quali attività fanno parte del tuo lavoro quotidiano?",
      lead: "Grazie per il tuo tempo! Vogliamo capire quali attività ci sono nella tua giornata e come si svolgono. Insieme alle risposte del tuo team capiamo dove guardare più da vicino, per riconoscere i processi e preparare miglioramenti e automazioni. I risultati vengono analizzati solo a livello di team.",
      leadMore: "Non servono termini tecnici. Descrivi il tuo lavoro come lo spiegheresti a una collega o a un collega. Pensa anche alle piccole routine, alle domande di chiarimento e alle attività che capitano solo ogni tanto.",
      areaTitle: "Perché le proposte siano adatte a te",
      area: "In quale area lavori?",
      areaPlaceholder: "Per esempio: controllo fatture, servizio clienti o acquisti",
      focus: "Cosa fa parte della tua giornata lavorativa?",
      focusPlaceholder: "Per esempio: fatture dei fornitori, domande dagli acquisti, cicli di pagamento",
      focusHelp: "Bastano poche parole chiave. Pax AI ne ricava proposte tra cui scegliere.",
      areaNote: "Non viene inviato con le tue attività. Serve solo per le idee di attività e per la tua panoramica.",
      exampleTitle: "Ecco come potrebbe essere un'attività",
      exampleHint: "Pensa a un'attività concreta con un inizio e una fine chiari. Potrai modificare le tue risposte anche dopo.",
      startCollect: "Avanti",
      title2: "Le tue attività",
      lead2: "Inserisci qui, una dopo l'altra, le attività che svolgi regolarmente al computer, ognuna con un nome e una breve descrizione. Inizia semplicemente dalla prima che ti viene in mente.",
      processTitle: (name) => `Quali attività ti vengono in mente per «${name}»?`,
      processLead: "Quali attività svolgi regolarmente al computer in quest'area? Inseriscile ognuna con un nome e una breve descrizione; alla fine Pax AI le ordina per tema. Se non ti viene in mente nulla, vai avanti.",
      otherTitle: "Altre attività",
      otherLead: "Ci sono attività che non rientrano in nessuna area? Aggiungile qui.",
      processStep: (number, total) => `Area ${number} di ${total}`,
      areas: "Aree",
      areasIntro: (n) => (n === 1 ? "Al vostro team è assegnata un'area. Poi puoi aggiungere altre attività." : `Al vostro team sono assegnate ${n} aree. Le vediamo una alla volta, poi puoi aggiungere altre attività.`),
      listIn: (name, count) => `Le tue attività in “${name}” (${count})`,
      otherStep: "Per finire",
      nextProcess: (name) => `Avanti: ${name}`,
      collected: (count) => count === 1 ? "1 attività raccolta" : `${count} attività raccolte`,
      ideas: {
        areas: {
          create: "Creare",
          check: "Controllare e approvare",
          book: "Registrare e inserire",
          maintain: "Modificare e aggiornare",
          incoming: "Pratiche in arrivo",
          report: "Analizzare e fare report",
        },
      },
      suggestions: "Già citate nel tuo team. Tocca se lo fai anche tu:",
      name: "Attività",
      namePlaceholder: (name) => `es. ${name}`,
      channelWords: /^(e-?mails?|mails?|posta|riunion[ei]|meetings?|chiamat[ae]|telefon[oi]|telefonat[ae]|archiviazione|comunicazione|ricerca|excel|sap|outlook|teams|documentazione|amministrazione|organizzazione|varie|altro)/i,
      coachChannel: (word) => `«${word}» è più uno strumento che un'attività. Di cosa si tratta? Per esempio «Rispondere alle domande dei fornitori».`,
      coachVerb: "Meglio descriverla come azione con un oggetto, per es. «Controllare le fatture» invece di «Controllo fatture».",
      description: "Descrivi in breve come si svolge di solito",
      descriptionHelp: "Basta una breve frase con parole tue.",
      descriptionPlaceholder: (text) => `es. ${text}`,
      askDescription: "Vuoi aggiungere una breve frase su come si svolge? Altrimenti clicca di nuovo su «Avanti».",
      next: "Avanti",
      classifyFor: (name) => `Classifica in breve: «${name}»`,
      classify: "Classifica in breve",
      classifyHint: "un clic per domanda",
      weights: { 5: "Piccola parte", 15: "Una buona parte", 30: "Gran parte" },
      frequency: "Quanto spesso?",
      taskDuration: "Quanto dura ogni volta?",
      digital: "Al computer?",
      continuity: "Fatta da una sola persona, tutta di seguito?",
      standardization: "Si svolge di solito allo stesso modo?",
      add: "Aggiungi attività",
      update: "Salva modifiche",
      cancelEdit: "Annulla",
      missing: (n) => (n === 1 ? "Manca ancora una risposta" : `Mancano ancora ${n} risposte`),
      list: (count) => `La tua lista (${count})`,
      empty: "Ancora nessuna attività. La maggior parte ne indica da 4 a 8.",
      edit: "Modifica",
      remove: "Rimuovi",
      removeTitle: "Rimuovere l’attività?",
      removeText: (name) => `«${name}» verrà rimossa dalla tua lista.`,
      pendingForm: "L'attività nel modulo non è ancora stata aggiunta. Prima aggiungila o svuota il modulo.",
      review: "Controlla le attività",
      reviewTitle: "La tua panoramica delle attività è giusta?",
      reviewLead: "Controlla le tue risposte. Puoi modificare, rimuovere o aggiungere attività.",
      noTasksReview: "Non hai inserito nessuna attività. Se va bene così, invia comunque il sondaggio: ci aiuta lo stesso.",
      reviewMore: "Manca un'attività? Magari una che capita solo ogni tanto?",
      reviewGrouping: "Pax AI sta ordinando le tue attività per tema …",
      reviewOther: "Altre attività",
      periodTitle: "L'attività capita durante la fase di rilevazione?",
      periodLabel: "Fase di rilevazione",
      periodRange: (from, until) => `dal ${from} al ${until}`,
      periodHint: "Sì o No aiuta a pianificare il progetto. Le attività con «No» restano semplicemente nella lista. Più avanti saranno altrettanto utili.",
      periodOpen: (count) => `${count === 1 ? "Per un'attività manca" : `Per ${count} attività manca`} ancora un Sì o un No per il periodo di rilevazione. Vuoi completarlo? Altrimenti clicca di nuovo su «Invia attività».`,
      inPeriod: "Nella fase di rilevazione?",
      addAnother: "Aggiungi un'altra attività",
      submit: "Invia attività",
      submitting: "Invio in corso …",
      sentTitle: "Grazie! Le tue attività sono state inviate",
      sentText: "Insieme alle risposte del tuo team ci mostrano dove guardare più da vicino.",
      sentChange: (date) => `Entro ${date} puoi ancora fare modifiche tramite questo link.`,
      sentEdit: "Modifica le attività",
    },
    select: {
      duration: "circa 2 minuti",
      title: "Quali attività guardiamo più da vicino?",
      lead: (tasks, themes) => `Avete indicato le vostre attività e abbiamo unito quelle uguali: ${tasks} attività in ${themes} ${themes === 1 ? "tema" : "temi"}.`,
      how: "Per ogni attività c'è già un consiglio. Cambialo solo dove non sei d'accordo.",
      leadFramework: (tasks, themes) => `Queste attività sono già nel framework del vostro settore: ${tasks} attività in ${themes} ${themes === 1 ? "tema" : "temi"}.`,
      howFramework: "Sono tutte su «Sì». Metti su «No» quelle da non guardare più da vicino.",
      meaning: "«Sì» significa: questa attività verrà analizzata più da vicino nel Task Mining.",
      criteria: "Consigliata significa:",
      criteriaList: ["soprattutto al computer", "fatta da una sola persona, tutta di seguito", "capita regolarmente"],
      title2: "Scegliere insieme",
      filters: { all: "Tutte", suitable: "Consigliate", not_suitable: "Meglio di no", unclear: "Non chiare" },
      mentions: (count) => `citata ${count}×`,
      inPeriod: (yes, no) => `nella rilevazione: ${yes}× sì, ${no}× no`,
      share: (percent) => ({ 5: "Piccola parte del lavoro", 15: "Una buona parte del lavoro", 30: "Gran parte del lavoro" })[weightOf(percent)],
      question: "Guardarla più da vicino?",
      yes: "Sì",
      no: "No",
      comment: "Commento",
      commentPlaceholder: "Facoltativo: perché?",
      missing: "Manca un'attività importante?",
      addMissing: "Aggiungi attività",
      addAnother: "Aggiungi un'altra attività",
      changed: (count) => count === 0 ? "Hai mantenuto tutti i consigli." : count === 1 ? "Hai cambiato 1 consiglio." : `Hai cambiato ${count} consigli.`,
      submit: "Fatto: invia la scelta",
      sentTitle: "Grazie, la tua scelta è arrivata!",
      sentText: (date) => `Entro ${date} puoi ancora modificarla tramite questo link.`,
      sentEdit: "Modifica la scelta",
    },
    done: {
      title: "La scelta è fatta",
      lead: "Ora il team di progetto guarderà più da vicino queste attività. Grazie per aver partecipato!",
      titleCollect: "La vostra lista di attività è pronta",
      leadCollect: "Queste sono le attività indicate dal vostro team. Il team di progetto ne ricava il framework. Grazie per aver partecipato!",
      votes: (yes, no) => `${yes} sì · ${no} no`,
      notSelected: "Non selezionata",
    },
    status: { suitable: "Consigliata", not_suitable: "Poco rilevante", unclear: "Valutazione non chiara", framework: "Dal framework" },
    reasons: {
      fits: "al computer, tutta di seguito, regolarmente",
      offline: "soprattutto senza computer",
      several_people: "coinvolge più persone",
      disputed: "risposte diverse nel team",
      unknown: "troppe poche risposte",
      partly_digital: "solo in parte al computer",
      interrupted: "con passaggi di consegne o attese",
      rare: "capita raramente",
      variable: "ogni volta diversa",
      too_short: "più che altro un singolo passo",
      framework: "nessuna risposta dal team",
    },
    values: {
      "Mainly digital": "Soprattutto",
      "Partly digital": "In parte",
      "Mainly offline": "Poco",
      "Yes": "Sì",
      "Partly, with handoffs or waiting": "Con passaggi o attese",
      "No": "No, più persone",
      "Daily": "Ogni giorno",
      "Weekly": "Ogni settimana",
      "Monthly": "Ogni mese",
      "Yearly or less often": "Più raramente",
      "Mostly consistent": "Quasi sempre uguale",
      "Some variation": "Un po' diversa",
      "Highly variable": "Ogni volta diversa",
      "Under 5 minutes": "Meno di 5 min",
      "5-30 minutes": "da 5 a 30 min",
      "30-60 minutes": "da 30 min a 1 h",
      "Over 1 hour": "Più di 1 h",
    },
    facts: {
      "Mainly digital": "al computer",
      "Partly digital": "in parte al computer",
      "Mainly offline": "poco al computer",
      "Yes": "tutta di seguito",
      "Partly, with handoffs or waiting": "con passaggi",
      "No": "più persone",
      "Mostly consistent": "quasi sempre uguale",
      "Some variation": "con varianti",
      "Highly variable": "ogni volta diversa",
    },
  },
  es: {
      locale: "es-ES",
      // Schrittanzeige oben rechts wie im Framework Assistant
      steps: { collect: ["Inicio", "Pax AI", "Tareas", "Revisar"], select: ["Inicio", "Elegir"] },
      lightMode: "Claro",
      darkMode: "Oscuro",
      product: "Task Mining",
      area: "Encuesta al equipo",
      stepOf: (step, total) => `Paso ${step} de ${total}`,
      duration: "Duración",
      anonymous: "Anónima: nadie ve quién ha escrito qué.",
      openUntil: (date) => `Abierta hasta el ${date}`,
      lateOpen: "El plazo ha terminado, pero todavía puedes participar.",
      notFound: "Esta encuesta no existe (o ya no existe). Revisa el enlace o pregunta al equipo del proyecto.",
      preparing: "Estamos preparando la lista común …",
      preparingHint: "Suele tardar menos de un minuto. La página se actualiza sola.",
      saveError: "No se ha podido guardar. Vuelve a intentarlo en un momento.",
      stageChanged: "La fase de recogida ya ha terminado. Ahora toca elegir entre todos.",
      stageChangedSent: "¡Gracias, tus tareas ya están dentro! Hemos reunido todas las respuestas. Ahora toca elegir entre todos.",
      draftSaved: "Progreso guardado",
      draftSavedEverywhere: "Progreso guardado. También puedes seguir en otro dispositivo",
      alreadySent: "Ya has enviado tus respuestas, seguramente desde otro dispositivo. ¡Gracias por participar!",
      back: "Atrás",
      start: "Empezar",
      optional: "opcional",
      departmentLabel: "Departamento",
      assist: {
        title: "¿Quieres ayuda para reunir tus tareas?",
        lead: "Pax AI puede proponerte ideas de tareas a partir de tus respuestas. Tú decides cuáles encajan con tu trabajo y puedes adaptarlas.",
        yes: "Sí, muéstrame ideas",
        no: "No, escribo yo",
        loading: "Pax AI está preparando ideas de tareas …",
        error: "Ahora mismo no hay ideas de tareas para tu área. Aquí tienes ejemplos generales.",
        ideasTitle: "Ideas de tareas de Pax AI",
        examplesTitle: "Ejemplos de tareas",
        ideasHint: "Elige una actividad. Al tocarla, la idea pasa al formulario y allí puedes adaptarla.",
        more: "Nuevas propuestas",
        moreLoading: "Pax AI busca nuevas propuestas …",
        show: "Mostrar",
        hide: "Ocultar",
      },
      collect: {
        // Startseite (Rueckmeldung 04.10.): es geht um das Team und seinen Alltag - ein gemeinsames Projekt; Ablauf in vier Bildern
        introTitle: "Encuesta sobre las tareas de vuestro equipo",
        introLead: "Recogemos las tareas que se repiten con regularidad en vuestro equipo. Con ellas creamos la estructura básica del próximo proyecto de task mining, para que refleje vuestro trabajo real.",
        introToday: "Hoy solo se trata del paso 1. Lo demás vendrá después, junto con tu equipo.",
        introCardLabel: "Hoy",
        introCardTitle: "Recoge tus tareas",
        introCardText: "Con tus propias palabras. Si quieres, Pax AI te ayuda.",
        introTrustTeam: "Analizado solo a nivel de equipo",
        introTrustTogether: "Lo demás, junto con tu equipo",
        duration: "unos 15 minutos",
        title: "¿Qué tareas forman parte de tu día a día?",
        lead: "¡Gracias por dedicarnos tu tiempo! Queremos entender qué tareas surgen en tu día a día y cómo se hacen. Junto con las respuestas de tu equipo, decidimos dónde mirar con más detalle, para reconocer procesos y preparar mejoras y automatizaciones. Los resultados solo se analizan a nivel de equipo.",
        leadMore: "No necesitas términos técnicos. Describe tu trabajo como se lo explicarías a un compañero o una compañera. Piensa también en pequeñas rutinas, consultas y tareas que solo aparecen de vez en cuando.",
        areaTitle: "Para que las propuestas encajen contigo",
        area: "¿En qué área trabajas?",
        areaPlaceholder: "Por ejemplo: revisión de facturas, atención al cliente o compras",
        focus: "¿Qué forma parte de tu día a día?",
        focusPlaceholder: "Por ejemplo: facturas de proveedores, consultas de compras, pagos",
        focusHelp: "Bastan unas palabras clave. Pax AI te propone ideas entre las que eliges.",
        areaNote: "No se envía con tus tareas. Solo sirve para las ideas de tareas y para tu resumen.",
        exampleTitle: "Así podría ser una tarea",
        exampleHint: "Piensa en una tarea concreta con un inicio y un final claros. Podrás editar tus respuestas más adelante.",
        startCollect: "Siguiente",
        title2: "Tus tareas",
        lead2: "Añade aquí, una tras otra, las tareas que haces con regularidad en el ordenador, cada una con un nombre y una breve descripción. Empieza simplemente por la primera que se te ocurra.",
        processTitle: (name) => `¿Qué tareas se te ocurren para «${name}»?`,
        processLead: "¿Qué tareas haces con regularidad en el ordenador en esta área? Añade cada una con un nombre y una breve descripción; al final, Pax AI las ordena por temas. Si no se te ocurre nada, continúa.",
        otherTitle: "Otras tareas",
        otherLead: "¿Hay tareas que no encajan en ningún área? Añádelas aquí.",
        processStep: (number, total) => `Área ${number} de ${total}`,
        areas: "Áreas",
        areasIntro: (n) => (n === 1 ? "Vuestro equipo tiene asignada un área. Después puedes añadir otras tareas." : `Vuestro equipo tiene asignadas ${n} áreas. Las vemos una a una y después puedes añadir otras tareas.`),
        listIn: (name, count) => `Tus tareas en «${name}» (${count})`,
        otherStep: "Para terminar",
        nextProcess: (name) => `Siguiente: ${name}`,
        collected: (count) => count === 1 ? "1 tarea recopilada" : `${count} tareas recopiladas`,
        ideas: {
          areas: {
            create: "Crear y dar de alta",
            check: "Revisar y aprobar",
            book: "Contabilizar y registrar",
            maintain: "Cambiar y mantener",
            incoming: "Gestionar entradas",
            report: "Analizar e informar",
          },
        },
        suggestions: "Ya lo ha mencionado tu equipo. Tócalo si tú también lo haces:",
        name: "Tarea",
        namePlaceholder: (name) => `p. ej. ${name}`,
        channelWords: /^(e-?mails?|correos?|mails?|reuni[oó]n(es)?|llamadas?|tel[eé]fono|archivo|comunicaci[oó]n|investigaci[oó]n|b[uú]squedas?|excel|sap|outlook|teams|documentaci[oó]n|administraci[oó]n|organizaci[oó]n|varios|otros)/i,
        coachChannel: (word) => `«${word}» es más una herramienta que una tarea. ¿De qué se trata? Por ejemplo, «Responder consultas de proveedores».`,
        coachVerb: "Lo mejor es describirlo como una actividad con un objeto, p. ej. «Revisar facturas» en lugar de «Revisión de facturas».",
        description: "Describe brevemente cómo se hace normalmente",
        descriptionHelp: "Basta una frase corta con tus palabras.",
        descriptionPlaceholder: (text) => `p. ej. ${text}`,
        askDescription: "¿Añades una frase corta sobre cómo se hace? Si no, vuelve a hacer clic en «Siguiente».",
        next: "Siguiente",
        classifyFor: (name) => `Clasificar brevemente: «${name}»`,
        classify: "Clasificar brevemente",
        classifyHint: "un clic por pregunta",
        weights: { 5: "Una parte pequeña", 15: "Una buena parte", 30: "Una gran parte" },
        frequency: "¿Con qué frecuencia?",
        taskDuration: "¿Cuánto tarda una vez?",
        digital: "¿En el ordenador?",
        continuity: "¿La hace una sola persona de una vez?",
        standardization: "¿Se hace casi siempre igual?",
        add: "Añadir tarea",
        update: "Guardar cambios",
        cancelEdit: "Cancelar",
        missing: (n) => (n === 1 ? "Falta todavía una respuesta" : `Faltan todavía ${n} respuestas`),
        list: (count) => `Tu lista (${count})`,
        empty: "Todavía no hay tareas. La mayoría menciona entre 4 y 8.",
        edit: "Editar",
        remove: "Quitar",
        removeTitle: "¿Quitar la tarea?",
        removeText: (name) => `«${name}» se quitará de tu lista.`,
        pendingForm: "La tarea del formulario todavía no se ha añadido. Añádela o vacía el formulario primero.",
        review: "Revisar tareas",
        reviewTitle: "¿Está bien tu resumen de tareas?",
        reviewLead: "Revisa tus respuestas. Puedes editar, quitar o añadir tareas.",
        noTasksReview: "No has añadido ninguna tarea. Si es así, envía la encuesta de todos modos: también nos ayuda.",
        reviewMore: "¿Falta alguna tarea, quizá una que solo aparece de vez en cuando?",
        reviewGrouping: "Pax AI está ordenando tus tareas por temas …",
        reviewOther: "Otras tareas",
        periodTitle: "¿Aparece la tarea durante la fase de recogida de datos?",
        periodLabel: "Fase de recogida de datos",
        periodRange: (from, until) => `del ${from} al ${until}`,
        periodHint: "Sí o No ayuda a planificar el proyecto. Las tareas con «No» siguen en la lista. Más adelante serán igual de valiosas.",
        periodOpen: (count) => `${count === 1 ? "A una tarea le falta" : `A ${count} tareas les falta`} todavía un Sí o un No para el periodo de recogida. ¿Lo completas? Si no, vuelve a hacer clic en «Enviar tareas».`,
        inPeriod: "¿En la fase de recogida de datos?",
        addAnother: "Añadir otra tarea",
        submit: "Enviar tareas",
        submitting: "Enviando …",
        sentTitle: "¡Gracias! Tus tareas se han enviado",
        sentText: "Junto con las respuestas de tu equipo, nos muestran dónde mirar con más detalle.",
        sentChange: (date) => `Hasta el ${date} todavía puedes hacer cambios con este enlace.`,
        sentEdit: "Editar tareas",
      },
      select: {
        duration: "unos 2 minutos",
        title: "¿Qué tareas miramos con más detalle?",
        lead: (tasks, themes) => `Habéis indicado vuestras tareas y hemos unido las que son iguales: ${tasks} ${tasks === 1 ? "tarea" : "tareas"} en ${themes} ${themes === 1 ? "tema" : "temas"}.`,
        how: "Cada tarea ya tiene una recomendación. Cámbiala solo si no estás de acuerdo.",
        leadFramework: (tasks, themes) => `Estas tareas ya están en el framework de vuestra área: ${tasks} ${tasks === 1 ? "tarea" : "tareas"} en ${themes} ${themes === 1 ? "tema" : "temas"}.`,
        howFramework: "Todas están en «Sí». Cambia a «No» lo que no haga falta mirar con más detalle.",
        meaning: "«Sí» significa: esta tarea se analizará con más detalle en el Task Mining.",
        criteria: "Recomendada significa:",
        criteriaList: ["sobre todo en el ordenador", "la hace una sola persona de una vez", "se repite con regularidad"],
        title2: "Elegir entre todos",
        filters: { all: "Todas", suitable: "Recomendadas", not_suitable: "Mejor no", unclear: "Dudosas" },
        mentions: (count) => `mencionada ${count}×`,
        inPeriod: (yes, no) => `en la recogida: ${yes}× sí, ${no}× no`,
        share: (percent) => ({ 5: "Una parte pequeña del trabajo", 15: "Una buena parte del trabajo", 30: "Una gran parte del trabajo" })[weightOf(percent)],
        question: "¿Mirarla con más detalle?",
        yes: "Sí",
        no: "No",
        comment: "Comentario",
        commentPlaceholder: "Opcional: ¿por qué?",
        missing: "¿Falta alguna tarea importante?",
        addMissing: "Añadir tarea",
        addAnother: "Añadir otra tarea",
        changed: (count) => count === 0 ? "Has mantenido todas las recomendaciones." : count === 1 ? "Has cambiado 1 recomendación." : `Has cambiado ${count} recomendaciones.`,
        submit: "Listo: enviar selección",
        sentTitle: "¡Gracias, tu selección ha llegado!",
        sentText: (date) => `Hasta el ${date} todavía puedes cambiarla con este enlace.`,
        sentEdit: "Editar selección",
      },
      done: {
        title: "La selección está lista",
        lead: "El equipo del proyecto va a mirar ahora estas tareas con más detalle. ¡Gracias por participar!",
        titleCollect: "Vuestra lista de tareas está lista",
        leadCollect: "Estas son las tareas que ha mencionado vuestro equipo. Con ellas, el equipo del proyecto crea el framework. ¡Gracias por participar!",
        votes: (yes, no) => `${yes} sí · ${no} no`,
        notSelected: "No seleccionadas",
      },
      status: { suitable: "Recomendada", not_suitable: "Poco relevante", unclear: "Sin valoración clara", framework: "Del framework" },
      reasons: {
        fits: "en el ordenador, de una vez, con regularidad",
        offline: "sobre todo sin ordenador",
        several_people: "participan varias personas",
        disputed: "respuestas distintas en el equipo",
        unknown: "pocas respuestas",
        partly_digital: "solo en parte en el ordenador",
        interrupted: "con traspasos o esperas",
        rare: "ocurre pocas veces",
        variable: "cada vez es distinta",
        too_short: "más bien un paso suelto",
        framework: "sin datos del equipo",
      },
      values: {
        "Mainly digital": "Sobre todo",
        "Partly digital": "En parte",
        "Mainly offline": "Casi nada",
        "Yes": "Sí",
        "Partly, with handoffs or waiting": "Con traspasos o esperas",
        "No": "No, varias personas",
        "Daily": "A diario",
        "Weekly": "Cada semana",
        "Monthly": "Cada mes",
        "Yearly or less often": "Con menos frecuencia",
        "Mostly consistent": "Casi siempre igual",
        "Some variation": "Algo distinta",
        "Highly variable": "Cada vez distinta",
        "Under 5 minutes": "Menos de 5 min",
        "5-30 minutes": "de 5 a 30 min",
        "30-60 minutes": "de 30 min a 1 h",
        "Over 1 hour": "Más de 1 h",
      },
      facts: {
        "Mainly digital": "en el ordenador",
        "Partly digital": "en parte en el ordenador",
        "Mainly offline": "casi sin ordenador",
        "Yes": "de una vez",
        "Partly, with handoffs or waiting": "con traspasos",
        "No": "varias personas",
        "Mostly consistent": "casi siempre igual",
        "Some variation": "con variantes",
        "Highly variable": "cada vez distinta",
      },
    },
};
